/* eslint-disable max-len */
/* eslint-disable no-nested-ternary */
/* eslint jsx-a11y/no-static-element-interactions: 0 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { replace } from 'react-router-redux';
import moment from 'moment-timezone';
import qs from 'qs';
import { Link, withRouter } from 'react-router';
import { withTranslation } from 'react-i18next';
import { markdownToDraft } from 'markdown-draft-js';
import { EditorState, convertFromRaw } from 'draft-js';
import Auth from '@aws-amplify/auth';
import { t } from 'i18next';
import {
  Dimmer,
  Dropdown,
  Grid,
  Table,
  Loader,
  Icon,
  Label,
  Header,
  Menu,
  Popup,
  Image,
  Button,
  Accordion,
  Transition,
  List,
} from 'semantic-ui-react';

import config from '../../../config';
import isNumber from '../../utils/numbers/isNumber';
import { decodeSearch, encodeSearch } from '../../utils/url';
import isbase64 from '../../utils/isbase64';
import BookingDatePicker from './UCBookingDatePicker';
import { BookingSelectList } from './UCBookingSelectList';
import { BookingSelectListMultiple } from './UCBookingSelectListMultiple';
import { flashErrorMessage, flashSuccessMessage } from '../../actions/flash';
import { fetchM, fetchAPI, serverRequestGet } from '../../actions/fetchM';
import PageNav from './../PageNav';
import SearchIn from './UCSearchIn';
import SortButton from './../UpdatedComponents/UCSortButton';
import Timestamp from './../Timestamp';
import FixedBarStatus from './UCFixedBarStatus';
import * as endpoints from '../../constants/apiEndpoints';
import { AGING_DATE_RANGE } from '../../constants/dateRanges';
import {
  BOOKING_STATUS_PENDING_CANCELLATION,
  bookingStatusesAll,
  bookingStatusesTabs,
  isBookingPendingCancellation,
} from '../../constants/bookingStatuses';
import { getLawyerCaseStatuses, LAWYER_CASE_TYPES, LAWYER_ALL_STATUSES, DEVELOPER_CANCELLED } from '../../constants/lawyerCaseStatuses';
import PAYMENT_STATUSES from '../../constants/paymentStatuses';
import { namespaces, TRANSLATION_FILES } from '../../constants/translation';
import { cancellationCategoryLabel } from '../OpportunityCancelModal';
import { titleCase } from '../../utils/strings';
import BookingStatusDropdown from './UCBookingStatusDropdown';
import DownloadSvg from '../../assets/icons/download.svg';
import SortSvg from '../../assets/icons/sort.svg';
import ClockDisabledSvg from '../../assets/icons/clock_disabled.svg';
import ClockYellowSvg from '../../assets/icons/clock_yellow.svg';
import ClockRedSvg from '../../assets/icons/clock_red.svg';
import NotesDisabledSvg from '../../assets/icons/notes_disabled.svg';
import NotesSvg from '../../assets/icons/notes.svg';
import CreditCardDisabledSvg from '../../assets/icons/credit_card_disabled.svg';
import CreditCardYellowSvg from '../../assets/icons/credit_card_yellow.svg';
import CreditCardGreenSvg from '../../assets/icons/credit_card_green.svg';
import LegalDisabledSvg from '../../assets/icons/legal_disabled.svg';
import LegalSvg from '../../assets/icons/legal.svg';
import LoanDisabledSvg from '../../assets/icons/loan_disabled.svg';
import LoanSvg from '../../assets/icons/loan.svg';
import UserSvg from '../../assets/icons/user.svg';
import BuildingSvg from '../../assets/icons/building.svg';
import CalendarSvg from '../../assets/icons/calendar.svg';
import InfoPopup from './Basic/UCBPopup';
import StatusFlag from './Basic/UCBStatusFlag';
import BANK_CASE_STATUSES from '../../constants/bankCaseStatuses';
import { getProgressPercent, getRemainingTimeSimple } from '../../utils/time';
import { fetchWithCacheSWR } from '../../utils/fetchWithCacheSWR';
import { isCountryVietnam } from '../../constants/countries';
import { bookingIDCellValue, createdByLabel, showBookingIDColumn as vnShowBookingIDColumn, showsPaymentExcelExport, unitQuotaChipLabel } from '../../utils/vietnam';

const isPRS = config.get('prs');

const tabs = [
  { value: 'all', name: 'all', text: 'All', header: 'Latest Bookings' },
  { value: 'aging_by_units', name: 'aging_by_units', text: 'Aging By Units', header: 'Aging By Units' },
  { value: 'aging_by_bankers', name: 'aging_by_bankers', text: 'Aging By Bankers', header: 'Aging By Bankers' },
  { value: 'aging_by_lawyers', name: 'aging_by_lawyers', text: 'Aging By Lawyers', header: 'Aging By Lawyers' },
];

const allFilterNames = [
  'search',
  'searchIn',
  'bookingStatusMulti',
  'dateRange',
  'dateFrom',
  'dateTo',
  'cancelledDateRange',
  'cancelledDateFrom',
  'cancelledDateTo',
  'expiredDateRange',
  'expiredDateFrom',
  'expiredDateTo',
  'bookedDateRange',
  'bookedDateFrom',
  'bookedDateTo',
  'soldDateRange',
  'soldDateFrom',
  'soldDateTo',
  'paymentStatus',
  'filteredProjects',
  'agingRange',
  'loanStatus',
  'agingDuration',
  'lawyerCaseType',
  'lawyerCaseStatus',
];

class BookingsList extends Component {
  static contextTypes = {
    store: PropTypes.object,
    router: PropTypes.object,
  }
  static propTypes = {
    globalSettings: PropTypes.shape({
      data: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    }),
    appConfig: PropTypes.shape({
      data: PropTypes.shape({
        companyID: PropTypes.number,
        lawyerIsEnabled: PropTypes.bool,
      }),
    }),
    where: PropTypes.shape({}),
    projectUnitID: PropTypes.string,
    onLoading: PropTypes.func,
    noScrollTop: PropTypes.bool,
    location: PropTypes.shape({
      query: PropTypes.object,
      search: PropTypes.string,
      pathname: PropTypes.string,
    }),
    auth: PropTypes.shape({
      isBranchLeader: PropTypes.bool,
      isHeadquarters: PropTypes.bool,
      isBranchLeaderSupervisor: PropTypes.bool,
      isSuperAdmin: PropTypes.bool,
      groups: PropTypes.arrayOf(PropTypes.shape({
        code: PropTypes.string,
      })),
      companyBranch: PropTypes.shape({
        isExternal: PropTypes.bool,
      }),
      company: PropTypes.shape({
        countryCode: PropTypes.string,
      }),
    }),
    hideBookingList: PropTypes.bool,
    bookingListLength: PropTypes.func,
    isUnitOverview: PropTypes.bool,
    t: PropTypes.func,
  }
  static defaultProps = {
    hideBookingList: false,
  }
  static mapStateToProps = state => ({
    auth: state.auth,
    appConfig: state.appConfig,
    globalSettings: state.globalSettings,
  })
  static getPropsToState = (props) => {
    const query = decodeSearch(props.location.search);
    const currentPage = parseInt(query.page, 10) || 1;
    const search = query.search || '';
    const searchIn = query.searchIn || '';
    const dateRange = query.dateRange || '';
    const cancelledDateRange = query.cancelledDateRange || '';
    const expiredDateRange = query.expiredDateRange || '';
    const bookedDateRange = query.bookedDateRange || '';
    const soldDateRange = query.soldDateRange || '';
    const loanStatus = query.loanStatus || [];
    const duration = query.duration || '';
    const bookingStatus = query.bookingStatus || '';
    const bookingStatusMulti = query.bookingStatusMulti || [];
    const agingRange = query.agingRange || '';
    const agingDuration = query.agingDuration || '';
    const paymentStatus = query.paymentStatus || [];
    const lawyerCaseType = query.lawyerCaseType || '';
    const lawyerCaseStatus = query.lawyerCaseStatus || '';
    const projectFilter = (isbase64(query.projectFilter) && qs.parse(atob(query.projectFilter)).name) || '';
    const staffFilter = (isbase64(query.staffFilter) && qs.parse(atob(query.staffFilter)).name) || '';
    const dateFrom = query.dateFrom ? query.dateFrom : '';
    const dateTo = query.dateTo ? query.dateTo : '';
    const cancelledDateFrom = query.cancelledDateFrom ? query.cancelledDateFrom : '';
    const cancelledDateTo = query.cancelledDateTo ? query.cancelledDateTo : '';
    const expiredDateFrom = query.expiredDateFrom ? query.expiredDateFrom : '';
    const expiredDateTo = query.expiredDateTo ? query.expiredDateTo : '';
    const bookedDateFrom = query.bookedDateFrom ? query.bookedDateFrom : '';
    const bookedDateTo = query.bookedDateTo ? query.bookedDateTo : '';
    const soldDateFrom = query.soldDateFrom ? query.soldDateFrom : '';
    const soldDateTo = query.soldDateTo ? query.soldDateTo : '';
    const loadingProjectSearch = false;
    const loadingStaffSearch = false;
    const findProjectResults = [];
    const findStaffResults = [];
    const loadingMessage = `${props.t('Loading', { ns: TRANSLATION_FILES.translation })}...`;
    const noResultsMessage = loadingMessage;
    const noStaffResultsMessage = loadingMessage;
    const hasLawyerAccess = props.auth && props.auth.companyBranch && !props.auth.isExternalAgent;
    const lawyerIsEnabled = props.appConfig && props.appConfig.data && props.appConfig.data.lawyerIsEnabled && hasLawyerAccess;
    // const hasAccess = props.auth.isHeadquarters || props.auth.isSuperAdmin;
    // CPI-1209 (A37): Vietnam has no lawyer module, so the Aging By Lawyers tab is dropped there.
    const showLawyerTab = lawyerIsEnabled &&
      !isCountryVietnam(props.auth && props.auth.company && props.auth.company.countryCode);
    const tabss = showLawyerTab ? tabs : tabs.filter(t => t.value !== 'aging_by_lawyers');
    const currentTab = tabss.some(t => t.value === query.tab) ? query.tab : tabs[0].value;
    const screenWidth = window.innerWidth;
    return {
      search,
      searchIn,
      dateRange,
      cancelledDateRange,
      expiredDateRange,
      bookedDateRange,
      soldDateRange,
      loanStatus,
      duration,
      bookingStatus,
      bookingStatusMulti,
      agingRange,
      agingDuration,
      paymentStatus,
      projectFilter,
      staffFilter,
      dateTo,
      dateFrom,
      cancelledDateFrom,
      cancelledDateTo,
      expiredDateFrom,
      expiredDateTo,
      bookedDateFrom,
      bookedDateTo,
      soldDateFrom,
      soldDateTo,
      loadingProjectSearch,
      loadingStaffSearch,
      findProjectResults,
      findStaffResults,
      noResultsMessage,
      noStaffResultsMessage,
      currentPage,
      currentTab,
      lawyerCaseStatus,
      lawyerCaseType,
      tabss,
      stringifyQuery: '',
      screenWidth,
    };
  }
  static summaryDefault = {
    count: 0,
    reservedCount: 0,
    bookedCount: 0,
    cancelledDeveloperCount: 0,
    pendingCancellationCount: 0,
    cancelledCount: 0,
    soldCount: 0,
    loanCount: 0,
  }
  constructor(props) {
    super(props);
    const state = BookingsList.getPropsToState(props);
    const summary = Object.assign({}, BookingsList.summaryDefault);
    this.state = {
      loading: true,
      count: 0,
      limit: 0,
      offset: 0,
      data: [],
      summary,
      ...state,
      mpUserLoading: false,
      mpUserDetails: {},
      isChanging: false,
      projectOpts: [],
      filteredProjects: [],
      activeAccordionIndex: -1,
      isMobile: state.screenWidth <= 767,
      isTablet: state.screenWidth > 767 && state.screenWidth <= 991,
      isComputer: state.screenWidth > 991,
      projectArData: [],
      systemData: [],
      allBankCases: [],
      hasDropCase: false,
    };
  }
  componentDidMount() {
    const query = decodeSearch(this.props.location.search);
    if (!isPRS) {
      this.fetchSystemSettings();
    }
    this.fetchProjects();
    if (!isNumber(query.page) || query.page <= 0) {
      delete query.page;
    }
    const hasLawyerAccess = this.props.auth && this.props.auth.companyBranch && !this.props.auth.isExternalAgentLeader;
    const lawyerIsEnabled = this.props.appConfig && this.props.appConfig.data && this.props.appConfig.data.lawyerIsEnabled && hasLawyerAccess;
    // CPI-1209 (A37): a bookmarked ?tab=aging_by_lawyers is dropped for Vietnam too.
    const showLawyerTab = lawyerIsEnabled && !isCountryVietnam(this.props.auth.company.countryCode);
    const tabss = showLawyerTab ? tabs : tabs.filter(t => t.value !== 'aging_by_lawyers');
    if (query.tab && !tabss.some(t => t.value === query.tab)) {
      delete query.tab;
    }
    this.replaceQuery(query);
    this.handleResize();
    this.setStickyWidth();
    this.updateStickyShadows();
    window.addEventListener('resize', this.handleResize);
    window.addEventListener('resize', this.setStickyWidth);
    window.addEventListener('resize', this.updateStickyShadows);
  }
  componentWillReceiveProps(nextProps) {
    const { currentTab } = this.state;
    const state = BookingsList.getPropsToState(nextProps);
    this.setState(state, () => {
      if (currentTab !== state.currentTab) {
        this.replaceQuery({
          tab: state.currentTab,
        }, true);
      }
    });
  }
  componentWillUnmount() {
    if (this.setTimer) {
      clearTimeout(this.setTimer);
    }
    if (this.setStaffTimer) {
      clearTimeout(this.setStaffTimer);
    }
    window.removeEventListener('resize', this.handleResize);
    window.removeEventListener('resize', this.setStickyWidth);
    window.removeEventListener('resize', this.updateStickyShadows());
  }
  getStatusCount = (status) => {
    const { summary } = this.state;
    if (this.state.loading) {
      return '...';
    }
    switch (status) {
      case 'total':
        return summary.count;
      case 'reserved':
        return summary.reservedCount;
      case 'booked':
        return summary.bookedCount;
      case BOOKING_STATUS_PENDING_CANCELLATION:
        return summary.pendingCancellationCount || 0;
      case 'cancelled_developer':
        return summary.cancelledDeveloperCount;
      case 'cancelled_availability':
        return summary.cancelledCount;
      case 'sold_spa_signed':
        return summary.soldCount;
      case 'expired':
        return summary.expiredCount || 0;
      default:
        return 0;
    }
  }
  getSelectedStatus = (status) => {
    const { bookingStatus } = this.state;
    if (status === 'total') {
      return bookingStatus === '';
    } else if (bookingStatus !== '') {
      return bookingStatus === status;
    }
    return false;
  }
  getTabHeader = () => {
    const { currentTab } = this.state;
    const { t, auth } = this.props;

    return t(currentTab === 'all' && isCountryVietnam(auth.company.countryCode) ? 'Latest Sales' : tabs.find(tab => currentTab === tab.value).header);
  }
  getBankCaseStatusColor = (status) => {
    if (status.startsWith('reject')) {
      return 'red';
    } else if (status.startsWith('pending')) {
      return 'yellow';
    } else if (status.startsWith('approved') || status.startsWith('success')) {
      return 'green';
    }
    return 'blue';
  }
  getBankCaseStatuses = (data) => {
    const values = [];
    if (data.bankCasesStatuses) {
      data.bankCasesStatuses.forEach((bcs) => {
        values.push({
          iconColor: this.getBankCaseStatusColor(bcs.status),
          value: bcs.bankShortName,
        });
      });
    }
    return values;
  }
  setMPUserLoading(loading = false) {
    return new Promise((res) => {
      this.setState({ mpUserLoading: loading }, () => {
        res(loading);
      });
    });
  }
  setLoadingProjectSearch(loadingProjectSearch = false) {
    return new Promise((res) => {
      this.setState({ loadingProjectSearch }, res);
    });
  }
  setLoadingStaffSearch(loadingStaffSearch = false) {
    return new Promise((res) => {
      this.setState({ loadingStaffSearch }, res);
    });
  }
  setBookings(data = []) {
    return new Promise((res) => {
      this.setState({
        data: data || [],
      }, () => {
        res(data);
      });
    });
  }
  setComponentState(state = {}) {
    return new Promise((res) => {
      this.setState(state, () => {
        res(state);
      });
    });
  }
  setLoading(loading = false) {
    return new Promise((res) => {
      this.setState({ loading }, () => {
        if (this.props.onLoading) {
          this.props.onLoading(loading);
        }
        res(loading);
      });
    });
  }
  getRowClassName = (statusID) => {
    if (statusID === 'cancelled_availability') {
      return 'row-colors booking_row_cancelled_availability';
    }
    if (statusID === 'cancelled_developer' || statusID === DEVELOPER_CANCELLED) {
      return 'row-colors booking_row_cancelled_developer';
    }
    return 'row-colors';
  }
  getAgingColor = (days = 0) => {
    if (days >= 30) {
      return 'red';
    }
    if (days >= 14) {
      return 'yellow';
    }
    return null;
  }
  getPaymentIcon = (paymentStatus) => {
    switch (paymentStatus) {
      case 'paid':
        return CreditCardGreenSvg;
      case 'partial_paid':
        return CreditCardYellowSvg;
      default:
        return CreditCardDisabledSvg;
    }
  }
  getAllFilterNames = (removeBookingStatus = false) => {
    if (removeBookingStatus) return allFilterNames.filter(fn => fn !== 'bookingStatusMulti');
    return allFilterNames;
  }
  async fetchSystemSettings() {
    const { store } = this.context;
    const { t } = this.props;
    let res;
    try {
      res = await store.dispatch(fetchM('/settings/', {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (e) {
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: t('An error occurred, please refresh page', { ns: TRANSLATION_FILES.translation }) }));
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const systemData = await res.json();
      await this.setState({
        systemData,
      });
    }
  }
  async fetchProjects() {
    const { store } = this.context;
    const { t } = this.props;
    const query = Object.assign({
      limit: 0,
      showAsOptions: false,
    });
    await this.setLoading(true);
    let res;

    try {
      res = await store.dispatch(fetchM(`/projects/?${qs.stringify(query)}`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (err) {
      if (err.res && err.res.status >= 399 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
      }
      await this.setLoading(false);
      Bugsnag.notifyException(err);
      store.dispatch(flashErrorMessage({ message: `${t('There was an error with your request. Please try again', { ns: TRANSLATION_FILES.translation })}.` }));
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const data = await res.json();
      let newProjectOpts = this.state.projectOpts;
      let newProjectArData = this.state.projectArData;
      if (data && data.length > 0) {
        newProjectOpts = data.map(d => ({ value: d.id, text: d.name }));
        newProjectArData = data.map(d => ({ ...d }));
      }
      await this.setComponentState({ projectOpts: newProjectOpts, projectArData: newProjectArData });
    }
    await this.setLoading(false);
  }
  async fetchBookings(q = {}) {
    await this.setLoading(true);
    const { t } = this.props;
    const { store } = this.context;
    const query = Object.assign(q, this.props.where || {});

    let res;

    if (this.props.appConfig && this.props.appConfig.data && this.props.appConfig.data.lawyerIsEnabled && this.state.currentTab === 'aging_by_lawyers') {
      if (query.projectFilter) {
        query.project_code = atob(query.projectFilter);
        delete query.projectFilter;
      }
      if (this.props.projectUnitID) {
        query.project_unit_id = this.props.projectUnitID;
      }
      if (this.props.appConfig && this.props.appConfig.data) {
        query.company_id = this.props.appConfig.data.companyID;
      }
      const limit = 10;
      query.limit = limit;
      query.from = (query.page - 1) * limit;
      delete query.tab;
      delete query.page;
      if (query.lawyerCaseStatus) {
        query.status = query.lawyerCaseStatus;
        delete query.lawyerCaseStatus;
      }
      if (query.lawyerCaseType) {
        query.type = query.lawyerCaseType;
        delete query.lawyerCaseType;
      }
      if (query.agingDuration && query.agingDuration.startsWith('more_than_')) {
        query.duration = parseInt(query.agingDuration.replace('more_than_', '').replace('_days', ''), 10);
        delete query.agingDuration;
      }
      if (query.searchIn === 'lawyer') {
        query.lawyer = query.search;
        delete query.search;
      }
      if (query.searchIn === 'firm') {
        query.firm = query.search;
        delete query.search;
      }
      try {
        res = await store.dispatch(fetchAPI('lawyerAPI', `${endpoints.BOOKING_AGING_CASES}/?${qs.stringify(query)}`, null, 'get', {
          'X-Api-Token': process.env.LAWYER_API_TOKEN,
        }));
      } catch (e) {
        Bugsnag.notifyException(e);
        await store.dispatch(flashErrorMessage({ message: t('An error occurred, please refresh page', { ns: TRANSLATION_FILES.translation }) }));
        await this.setLoading(false);
        return;
      }

      if (res) {
        const stringifyQuery = qs.stringify(query);
        const count = res.total_hits;
        const offset = query.from;
        await this.setBookings(res.items);
        if (this.props.hideBookingList) {
          this.props.bookingListLength(this.state.data.length);
        }
        if (this.state.data.length < 1 && query.from >= limit) {
          const que = decodeSearch(this.props.location.search);
          await this.setComponentState({
            offset: 0,
          });
          que.page = 1;
          this.replaceQuery(que);
        } else {
          // handle token.. etc
          await this.setComponentState({
            count,
            limit,
            offset,
            stringifyQuery,
          });
        }
      }

      await this.setLoading(false);
      return;
    }

    if (this.props.projectUnitID) {
      query.projectUnitID = this.props.projectUnitID;
    }
    const url = `/bookings/?${qs.stringify(query)}`;
    const urlOptions = {
      credentials: 'include',
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    };

    try {
      if (this.state.currentTab === 'aging_by_bankers') {
        res = await fetchWithCacheSWR(
          store,
          url,
          urlOptions,
          15000, // current ttl
          null,
          'ttl',
          'localStorage',
        );
      } else {
        res = await store.dispatch(fetchM(url, urlOptions));
      }
    } catch (err) {
      if (err.res && err.res.status >= 399 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
      }
      await this.setLoading(false);
      Bugsnag.notifyException(err);
      store.dispatch(flashErrorMessage({ message: `${t('There was an error with your request. Please try again', { ns: TRANSLATION_FILES.translation })}.` }));
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const count = parseInt(res.headers.get('M-Data-count'), 10);
      const limit = parseInt(res.headers.get('M-Data-limit'), 10);
      const offset = parseInt(res.headers.get('M-Data-offset'), 10) || 0;
      let data = await res.json();

      if (data && data.length > 0 && (this.state.currentTab === 'all' || this.state.currentTab === 'aging_by_units')) {
        data = await Promise.all(data.map(async (d) => {
          // TODO: comment first waiting for updated api calls+confirmation by backend team
          // let bookingCustomers = null;
          // if (this.state.currentTab === 'all') {
          //   bookingCustomers = await this.fetchBookingCustomers(d.id);
          // }

          // let lawyer = null;
          // let bookingBankCases = null;
          if (this.state.currentTab === 'all' || this.state.currentTab === 'aging_by_units') {
            // lawyer = await this.fetchAllLawyerCasesDetails(d.id);
            // bookingBankCases = d.loanTrackerLeadCode !== '' ? await this.fetchBankCaseDrops(d) : null;
          }

          return {
            ...d,
            // bookingCustomers,
            // lawyer,
            // bookingBankCases,
          };
        }));
      }
      await this.setBookings(data);
      if (this.props.hideBookingList) {
        this.props.bookingListLength(this.state.data.length);
      }
      if (this.state.data.length < 1 && query.page > 1) {
        const que = decodeSearch(this.props.location.search);
        que.page = 1;
        this.replaceQuery(que);
      } else {
        // handle token.. etc
        await this.setComponentState({
          count,
          limit,
          offset,
        });
      }
    }
    await this.setLoading(false);
    this.setStickyWidth();
    this.updateStickyShadows();
  }
  async fetchBookingCustomers(bookingID) {
    // intended loading no stop after to avoid flickering
    await this.setLoading(true);
    const { store } = this.context;
    let bookingCustomers = {};
    let res;
    try {
      res = await store.dispatch(fetchM(`/bookings/${bookingID}/`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (err) {
      if (err.res && err.res.status >= 399 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
      }
      Bugsnag.notifyException(err);
      store.dispatch(flashErrorMessage({ message: 'There was an error with your request. Please try again.' }));
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const data = await res.json();
      bookingCustomers = data.bookingCustomers;
    }
    return bookingCustomers;
  }
  async fetchBookingSummaries(q = {}) {
    await this.setLoading(true);
    const { store } = this.context;
    const { t } = this.props;
    const query = Object.assign(q, this.props.where || {});
    if (this.props.projectUnitID) {
      query.projectUnitID = this.props.projectUnitID;
    }
    let res;
    try {
      res = await store.dispatch(fetchM(`/bookings/summary/?${qs.stringify(query)}`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (e) {
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: t('An error occurred, please refresh page', { ns: TRANSLATION_FILES.translation }) }));
      await this.setLoading(false);
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const summary = await res.json();
      // handle token.. etc
      await this.setComponentState({ summary });
    }
  }
  fetchMarketplaceUserDetails = async (userID) => {
    const { store } = this.context;
    const { t } = this.props;
    const url = `/marketplace/staffs/${userID}/`;
    try {
      await this.setMPUserLoading(true);
      const response = await serverRequestGet(
        url,
        store,
      );
      if (response.error) {
        await store.dispatch(flashErrorMessage({ message: response.message }));
        return;
      }
      await this.setState({ mpUserDetails: response.data });
      await this.setMPUserLoading(false);
    } catch (e) {
      Bugsnag.notifyException(e);
      await this.setMPUserLoading(false);
      await store.dispatch(flashErrorMessage({ message: t('An error occurred, please refresh page', { ns: TRANSLATION_FILES.translation }) }));
    }
  }
  fetchAllLawyerCasesDetails = async (bookingID = null) => {
    // intended loading no stop after to avoid flickering
    await this.setLoading(true);
    let spaLawyer;
    let laLawyer;

    // Fetch SPA and LA cases in parallel
    const results = await Promise.all([
      this.fetchLawyerCases('SPA', bookingID),
      this.fetchLawyerCases('LA', bookingID),
    ]);

    for (let i = 0; i < results.length; i++) {
      const t = results[i];
      if (t.items && t.items.length > 0 && t.items[0].status !== DEVELOPER_CANCELLED) {
        const lawyer = await this.fetchLawyer(t.items[0].lawyer_id);
        if (lawyer) {
          if (t.type === 'SPA') {
            spaLawyer = lawyer;
          }
          if (t.type === 'LA') {
            laLawyer = lawyer;
          }
        }
      }
    }
    return {
      spaLawyer,
      laLawyer,
    };
  };
  async fetchLawyer(lawyerID = null) {
    if (!lawyerID) return null;
    const { store } = this.context;
    const { t } = this.props;
    let res;
    try {
      res = await store.dispatch(fetchAPI('lawyerAPI', endpoints.LAWYER(lawyerID), null, 'get', {
        'X-Api-Token': process.env.LAWYER_API_TOKEN,
      }));
      return res;
    } catch (e) {
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: t('An error occurred, please refresh page', { ns: TRANSLATION_FILES.translation }) }));
      return null;
    }
  }
  fetchLawyerCases = async (type, bookingID) => {
    const { store } = this.context;
    const query = {
      limit: 1,
      type,
    };
    let res;
    try {
      res = await store.dispatch(fetchAPI('lawyerAPI', `${endpoints.BOOKING_CASES(bookingID)}/?${qs.stringify(query)}`, null, 'get', {
        'X-Api-Token': process.env.LAWYER_API_TOKEN,
      }));
    } catch (e) {
      Bugsnag.notifyException(e);
      return [];
    }
    return res;
  }
  fetchBankCaseDrops = async (booking) => {
    const { store } = this.context;
    let res;
    let bankCases = {};
    try {
      res = await store.dispatch(fetchM(`/bookings/${booking.id}/loan_trackers/bank_cases/drop/`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': this.props.token,
        },
      }));
    } catch (err) {
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
        return bankCases;
      }
      Bugsnag.notifyException(err);
      // store.dispatch(flashErrorMessage({ message: `${t('There was an error with your request. Please try again', { ns: TRANSLATION_FILES.translation })}.` }));
      return bankCases;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const data = await res.json();
      if (data && data.length > 0) {
        bankCases = this.getAllBankCases(booking.bankCases, data);
      } else {
        bankCases = this.getAllBankCases(booking.bankCases);
      }
    }
    return bankCases;
  }
  getAllBankCases = (bankCases, bankCaseDrops) => {
    let hasDropCase = false;
    let allCases = [];
    if (bankCases) {
      const bankerIDs = new Set(bankCases.map(bc => bc.bankerID));
      allCases = bankCaseDrops ? [...bankCases, ...bankCaseDrops.filter((bcd) => {
        if (!bankerIDs.has(bcd.bankerID)) {
          hasDropCase = true;
          return true;
        }
      })] : [...bankCases];
    } else if (bankCaseDrops) {
      allCases = [...bankCaseDrops];
      hasDropCase = true;
    }

    return {
      ...allCases,
      hasDropCase,
    };
  }
  checkAutoReleaseTimer = (data, project) => {
    const { allBankCases, systemData } = this.state;
    // if booking is reserved & system's AR is turned on
    if (data && data.statusID === 'reserved' && systemData && project && systemData.arBookingExpIsEnabled) {
       const primaryBookingCustomer =
         (data.bookingCustomers && data.bookingCustomers.find(bc => bc.customerID === data.customerID)) ||
         data.bookingCustomer;

      const systemTimer = systemData.arBookingExpMoreThanMinutes !== '' && systemData.arBookingExpMoreThanMinutes !== '0';
      const projectTimer = project.arBookingExpMoreThanMinutes !== '' && project.arBookingExpMoreThanMinutes !== '0';
      const hasFrontIC = primaryBookingCustomer && primaryBookingCustomer.customer && primaryBookingCustomer.customer.icFrontDocumentID;
      const hasBackIC = primaryBookingCustomer && primaryBookingCustomer.customer && primaryBookingCustomer.customer.icBackDocumentID;
      const hasPaid = data.paymentStatusID && data.paymentStatusID === 'paid';
      const hasMortgageAdded = allBankCases && allBankCases.length > 0;
      const isBankerSourceOfFinance = data.paymentMethodID === 'own_banker' || data.paymentMethodID === 'referred_banker';
      const allPurchasersHasUploadedIC = data.bookingCustomers && data.bookingCustomers.length > 0 && data.bookingCustomers.filter(c => !c.customer.icFrontDocumentID || !c.customer.icBackDocumentID).length === 0;

      if (systemTimer || projectTimer) {
        const sysARPaymentEnabled = systemData.arBookingExpUnpaidIsEnabled;
        const sysARNricEnabled = systemData.arBookingExpNricPicIsEnabled;
        const sysARAllNricEnabled = systemData.arBookingExpAllNricPicsIsEnabled;
        const sysARMortgageEnabled = systemData.arBookingExpMortgageEnabled && isBankerSourceOfFinance;

        const projARPaymentEnabled = project.arBookingExpUnpaidIsEnabled;
        const projARNricEnabled = project.arBookingExpNricPicIsEnabled;
        const projARAllNricEnabled = project.arBookingExpAllNricPicsIsEnabled;
        const projARMortgageEnabled = project.arBookingExpMortgageEnabled && isBankerSourceOfFinance;

        // if either one of the system's requirements is enabled
        if (sysARPaymentEnabled || sysARNricEnabled || sysARAllNricEnabled || sysARMortgageEnabled) {
          // Payment enabled & payment condition fulfilled
          const sysConditionFulfilledPayment = sysARPaymentEnabled && hasPaid;
          // IC enabled & IC condition fulfilled
          let sysConditionFulfilledNric = sysARNricEnabled && hasBackIC && hasFrontIC;
          // Additional Purchasers IC enabled & all IC condition fulfilled
          if (sysARAllNricEnabled) {
            sysConditionFulfilledNric = allPurchasersHasUploadedIC;
          }
          // All IC enabled & All IC condition fulfilled
          // Mortgage enabled & mortgage condition fulfilled
          const sysConditionFulfilledMortgage = sysARMortgageEnabled && hasMortgageAdded;
          if (
            // all enabled and all conditions fulfilled
            (sysConditionFulfilledPayment && sysConditionFulfilledNric && sysARMortgageEnabled) ||
            // IC & mortgage enabled & both conditions fulfilled, payment disabled
            (!sysARPaymentEnabled && sysConditionFulfilledNric && sysConditionFulfilledMortgage) ||
            // Payment & mortgage enabled & both conditions fulfilled, NRIC disabled
            (sysConditionFulfilledPayment && !sysARNricEnabled && sysConditionFulfilledMortgage) ||
            // Payment & IC enabled & both conditions fulfilled, mortgage disabled
            (sysConditionFulfilledPayment && sysConditionFulfilledNric && !sysARMortgageEnabled) ||
            // Mortgage enabled & mortgage condition fulfilled, payment & nric disabled
            (!sysARPaymentEnabled && !sysARNricEnabled && sysConditionFulfilledMortgage) ||
            // IC enabled & IC condition fulfilled, payment & mortgage disabled
            (!sysARPaymentEnabled && sysConditionFulfilledNric && !sysARMortgageEnabled) ||
            // Payment enabled & payment condition fulfilled, nric & mortgage disabled
            (sysConditionFulfilledPayment && !sysARNricEnabled && !sysARMortgageEnabled)
          ) {
            return false;
          }
        // if project AR is turned on & 1 of the requirements is enabled
        } else if (project.arBookingExpIsEnabled && (projARPaymentEnabled || projARNricEnabled || projARAllNricEnabled || projARMortgageEnabled)) {
          // Payment enabled & payment condition fulfilled
          const projConditionFulfilledPayment = projARPaymentEnabled && hasPaid;
          // IC enabled & IC condition fulfilled
          let projConditionFulfilledNric = projARNricEnabled && hasBackIC && hasFrontIC;
          // Additional Purchasers IC enabled & all IC condition fulfilled
          if (projARAllNricEnabled) {
            projConditionFulfilledNric = allPurchasersHasUploadedIC;
          }
          // Mortgage enabled & mortgage condition fulfilled
          const projConditionFulfilledMortgage = projARMortgageEnabled && hasMortgageAdded;
          if (
            // all enabled and all conditions fulfilled
            (projConditionFulfilledPayment && projConditionFulfilledNric && projARMortgageEnabled) ||
            // IC & mortgage enabled & both conditions fulfilled, payment disabled
            (!projARPaymentEnabled && projConditionFulfilledNric && projConditionFulfilledMortgage) ||
            // Payment & mortgage enabled & both conditions fulfilled, NRIC disabled
            (projConditionFulfilledPayment && !projARNricEnabled && projConditionFulfilledMortgage) ||
            // Payment & IC enabled & both conditions fulfilled, mortgage disabled
            (projConditionFulfilledPayment && projConditionFulfilledNric && !projARMortgageEnabled) ||
            // Mortgage enabled & mortgage condition fulfilled, payment & nric disabled
            (!projARPaymentEnabled && !projARNricEnabled && projConditionFulfilledMortgage) ||
            // IC enabled & IC condition fulfilled, payment & mortgage disabled
            (!projARPaymentEnabled && projConditionFulfilledNric && !projARMortgageEnabled) ||
            // Payment enabled & payment condition fulfilled, nric & mortgage disabled
            (projConditionFulfilledPayment && !projARNricEnabled && !projARMortgageEnabled)
          ) {
            return false;
          }
        // project AR is not on
        } else if (!project.arBookingExpIsEnabled) {
          return false;
        // none of the requirements is on
        } else if (!sysARPaymentEnabled && !sysARNricEnabled && !sysARAllNricEnabled && !sysARMortgageEnabled && !projARPaymentEnabled && !projARNricEnabled && !projARAllNricEnabled && !projARMortgageEnabled) {
          return false;
        }
        return true;
      }
    }
    return false;
  }
  handleResize = () => {
    this.setState({
      screenWidth: window.innerWidth,
      isMobile: this.state.screenWidth <= 767,
      isTablet: this.state.screenWidth > 767 && this.state.screenWidth <= 991,
      isComputer: this.state.screenWidth > 991
    });
  }
  isTableOverflowing = (table) => {
    const parent = table.parentElement;
    return table.scrollWidth > parent.clientWidth;
  }
  setStickyWidth = () => {
    const table = document.querySelector('table');

    if (!table) return;

    if (this.isTableOverflowing(table)) {
      // Table is overflowing - apply sticky
      document.querySelectorAll('tr').forEach((row) => {
        // Left sticky
        const stickyLeftCols = Array.from(row.querySelectorAll('.uc-sticky-col.uc-left'));
        let cumulativeLeft = 0;
        stickyLeftCols.forEach((colParam) => {
          const col = colParam;
          col.style.left = `${cumulativeLeft}px`;
          cumulativeLeft += col.offsetWidth;
        });

        // Right sticky
        const stickyRightCols = Array.from(row.querySelectorAll('.uc-sticky-col.uc-right')).reverse();
        let cumulativeRight = 0;
        stickyRightCols.forEach((colParam) => {
          const col = colParam;
          col.style.right = `${cumulativeRight}px`;
          cumulativeRight += col.offsetWidth;
        });
      });

      // Enable shadows
      table.classList.add('has-overflow');
    } else {
      // No overflow - reset positions
      document.querySelectorAll('.uc-sticky-col').forEach((colElem) => {
        const col = colElem;
        col.style.left = '';
        col.style.right = '';
      });

      // Disable shadows
      table.classList.remove('has-overflow');
    }
  };
  updateStickyShadows = () => {
    // Remove old shadow classes
    document.querySelectorAll('.uc-sticky-shadow-left, .uc-sticky-shadow-right').forEach((el) => {
      el.classList.remove('uc-sticky-shadow-left', 'uc-sticky-shadow-right');
    });

    // Loop over all table rows
    document.querySelectorAll('tr').forEach((row) => {
      // Find the first sticky LEFT cell in this row
      const firstStickyLeft = row.querySelector('th.uc-sticky-col.uc-left, td.uc-sticky-col.uc-left');
      if (firstStickyLeft) {
        firstStickyLeft.classList.add('uc-sticky-shadow-left');
      }

      // Find the first sticky RIGHT cell in this row
      const firstStickyRight = row.querySelector('th.uc-sticky-col.uc-right, td.uc-sticky-col.uc-right');
      if (firstStickyRight) {
        firstStickyRight.classList.add('uc-sticky-shadow-right');
      }
    });
  }
  handleAccordionClick(e, valIndex) {
    const { index } = valIndex;
    this.setState(prevState => ({
      activeAccordionIndex: prevState.activeIndex === index ? -1 : index,
    }));
  }
  hasAccess(check = false) {
    if (
      this.props.auth.isBranchLeader ||
      this.props.auth.isHeadquarters ||
      this.props.auth.isSuperAdmin
    ) {
      return true;
    }
    return check;
  }
  hasAdminAccess(check = false) {
    if (
      this.props.auth.isHeadquarters ||
      this.props.auth.isSuperAdmin
    ) {
      return true;
    }
    return check;
  }
  hasInternalDEAccess(check = false) {
    const auth = this.props.auth;
    if (auth && auth.companyBranch && !auth.companyBranch.isExternal) {
      return true;
    }
    return check;
  }
  hasStaffAccess(check = false) {
    if (
      this.props.auth.isSuperAdmin ||
      this.props.auth.isHeadquarters
    ) {
      return true;
    }
    return check;
  }
  handleChangePage = (currentPage) => {
    const query = decodeSearch(this.props.location.search);
    query.page = currentPage;
    this.setState({ currentPage }, () => {
      this.replaceQuery(query);
    });
  }
  handleSortData = (sortColumn, sortDirection) => {
    const query = decodeSearch(this.props.location.search);
    query.sortColumn = sortColumn;
    query.sortDirection = sortDirection;
    this.replaceQuery(query, true);
  }
  handleClearFilter = (...queryArray) => {
    let hasQuery = false;
    let clearSearch = false;
    const query = decodeSearch(this.props.location.search);
    const filterArray = [...queryArray];
    filterArray.forEach((filter) => {
      if (filter === 'search') {
        clearSearch = true;
      }
      if (filter === 'agingRange' || filter === 'loanStatus') {
        delete query.sortColumn;
        delete query.sortDirection;
      }
      if (filter === 'filteredProjects') {
        delete query.projectCode;
        delete query.projectFilter;
        hasQuery = true;
        this.setState({
          filteredProjects: [],
          isChanging: false,
        });
      }
      if (query[filter] !== undefined) {
        delete query[filter];
        hasQuery = true;
        this.setState({ isChanging: false });
      }
    });
    const cb = () => {
      if (hasQuery) {
        this.replaceQuery(query, true);
      }
    };
    if (clearSearch) {
      this.setState({ search: '' }, () => {
        cb();
      });
    } else {
      cb();
    }
  }
  handleFilterOnChange = (value, queryName) => {
    const query = decodeSearch(this.props.location.search);
    query[queryName] = value;
    if (queryName === 'agingRange' || queryName === 'loanStatus') {
      delete query.sortColumn;
      delete query.sortDirection;
    }
    if (queryName === 'lawyerCaseType' && !getLawyerCaseStatuses(value).some(s => s.value === query.lawyerCaseStatus)) {
      delete query.lawyerCaseStatus;
    }
    let refetch = queryName !== 'searchIn' || (queryName === 'searchIn' && this.state.search.length > 0);
    if (queryName === 'dateRange' && query.dateRange === 'custom' && (!query.dateFrom || !query.dateTo)) {
      refetch = false;
    }
    if (queryName === 'cancelledDateRange' && query.cancelledDateRange === 'custom' && (!query.cancelledDateFrom || !query.cancelledDateTo)) {
      refetch = false;
    }
    if (queryName === 'expiredDateRange' && query.expiredDateRange === 'custom' && (!query.expiredDateFrom || !query.expiredDateTo)) {
      refetch = false;
    }
    if (queryName === 'bookedDateRange' && query.bookedDateRange === 'custom' && (!query.bookedDateFrom || !query.bookedDateTo)) {
      refetch = false;
    }
    if (queryName === 'soldDateRange' && query.soldDateRange === 'custom' && (!query.soldDateFrom || !query.soldDateTo)) {
      refetch = false;
    }
    this.replaceQuery(query, true, refetch);
  }
  handleSetDateRange = (name, from, to) => {
    const query = decodeSearch(this.props.location.search);
    switch (name) {
      case 'dateRange':
        query.dateFrom = from;
        query.dateTo = to;
        break;
      case 'cancelledDateRange':
        query.cancelledDateFrom = from;
        query.cancelledDateTo = to;
        break;
      case 'expiredDateRange':
        query.expiredDateFrom = from;
        query.expiredDateTo = to;
        break;
      case 'bookedDateRange':
        query.bookedDateFrom = from;
        query.bookedDateTo = to;
        break;
      case 'soldDateRange':
        query.soldDateFrom = from;
        query.soldDateTo = to;
        break;
      default:
        break;
    }
    this.replaceQuery(query, true);
  }
  handleReplaceStatus = (status = '') => {
    const query = decodeSearch(this.props.location.search);
    if (status !== '') {
      query.bookingStatus = status;
    } else {
      delete query.bookingStatus;
    }
    if (status !== 'cancelled_developer') {
      delete query.cancelledDateRange;
      delete query.cancelledDateFrom;
      delete query.cancelledDateTo;
    }
    if (status !== 'expired') {
      delete query.expiredDateRange;
      delete query.expiredDateFrom;
      delete query.expiredDateTo;
    }
    if (status !== 'booked') {
      delete query.bookedDateRange;
      delete query.bookedDateFrom;
      delete query.bookedDateTo;
    }
    if (status !== 'sold_spa_signed') {
      delete query.soldDateRange;
      delete query.soldDateFrom;
      delete query.soldDateTo;
    }
    this.replaceQuery(query);
  }
  handleSearchStaff = (value) => {
    const { t } = this.props;
    clearTimeout(this.setStaffTimer);
    const findStaffResults = [];
    const noStaffResultsMessage = `${t('Loading', { ns: TRANSLATION_FILES.translation })}...`;
    this.setState({ findStaffResults, noStaffResultsMessage, staffFilter: value }, () => {
      if (value !== '') {
        this.setStaffTimer = setTimeout(() => {
          this.searchStaffs(value);
        }, 500);
      }
    });
  }
  handleFilterProjects = (e, { name, value }) => {
    const { currentTab } = this.state;
    const isCurrentTabLawyer = currentTab === 'aging_by_lawyers';
    const filteredProjects = isCurrentTabLawyer ? [value] : value;
    this.setState({ filteredProjects }, () => {
      const query = decodeSearch(this.props.location.search);
      query[name] = btoa(value);
      this.replaceQuery(query, true);
    });
  }
  handleSelectProject = (project, queryName) => {
    const query = decodeSearch(this.props.location.search);
    const internalQuery = {};
    internalQuery.id = project.key;
    internalQuery.name = project.title;
    query[queryName] = btoa(qs.stringify(internalQuery));
    this.replaceQuery(query, true);
  }
  handleSelectStaff = (staff, queryName) => {
    const query = decodeSearch(this.props.location.search);
    const internalQuery = {};
    internalQuery.id = staff.key;
    internalQuery.name = staff.title;
    query[queryName] = btoa(qs.stringify(internalQuery));
    this.replaceQuery(query, true);
  }
  async searchStaffs(value) {
    const { store } = this.context;
    const { t } = this.props;
    await this.setLoadingStaffSearch(true);
    let res = null;
    try {
      res = await store.dispatch(fetchM(`/search/staffs/?isExternal=false&limit=3&search=${value}`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (err) {
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
      }
      await this.setLoadingStaffSearch(false);
      Bugsnag.notifyException(err);
      store.dispatch(flashErrorMessage({ message: `${t('There was an error with your request. Please try again', { ns: TRANSLATION_FILES.translation })}.` }));
    }
    if (!res.ok) {
      await this.setLoadingStaffSearch(false);
      throw new Error('Not OK');
    } else {
      await this.setLoadingStaffSearch(false);
      const json = await res.json();
      if (json) {
        const findStaffResults = json.map((obj) => {
          const newResults = {};
          newResults.key = obj.id.toString();
          newResults.title = obj.name;
          newResults.price = obj.preferredName;
          newResults.description = obj.email;
          return newResults;
        });
        this.setState({ findStaffResults });
      } else {
        const noStaffResultsMessage = `${t('No results found', { ns: TRANSLATION_FILES.translation })}.`;
        this.setState({ noStaffResultsMessage });
      }
    }
  }
  replaceQuery(query, resetPage = false, fetch = true) {
    const { store } = this.context;
    const { pathname, search } = this.props.location;
    const queryNew = query;
    if (resetPage) {
      queryNew.page = 1;
    }
    const bookingStatus = decodeSearch(search).bookingStatus;
    const bookingStatusMulti = decodeSearch(search).bookingStatusMulti;
    const paymentStatus = decodeSearch(search).paymentStatus;
    const lawyerCaseType = decodeSearch(search).lawyerCaseType;
    const lawyerCaseStatus = decodeSearch(search).lawyerCaseStatus;
    if (
      (query.bookingStatus && !bookingStatus) ||
      (query.bookingStatusMulti && !bookingStatusMulti) ||
      (query.paymentStatus && !paymentStatus) ||
      (query.lawyerCaseStatus && !lawyerCaseStatus) ||
      (query.lawyerCaseType && !lawyerCaseType)
    ) {
      queryNew.page = 1;
    }
    if (fetch) {
      this.fetchBookings(queryNew);
      if (this.state.currentTab === 'all') {
        this.fetchBookingSummaries(queryNew);
      }
    }
    store.dispatch(replace(`${pathname}?${encodeSearch(queryNew)}`));
  }
  exportURL = (fileType, primary = false, detailed = false) => {
    const { location, projectUnitID } = this.props;
    let url = `${config.get('bookApiURL')}/reports/bookings/`;
    if (location && location.search) {
      url += `${location.search}`;
    }
    if (projectUnitID) {
      url += `&projectUnitID=${projectUnitID}`;
    }
    if (primary) {
      url += '&primaryOnly=true';
    }
    url += `&fileType=${fileType}`;
    if (detailed) {
      url += '&detailed=true';
    }
    return url;
  }
  getDataTarget = idx => ({ 'data-bot-target': `row${idx + 1}-bookinglist` });
  getDatasetAttributes = (daname, davalue) => {
    let newDavalue = davalue;
    if (newDavalue === '') newDavalue = 'NULL';
    if (newDavalue === 'Not Applicable') newDavalue = 'N/A';
    const datasetName = `data-bot-${daname}`;
    return {
      [datasetName]: newDavalue,
    };
  }
  // CPI-974 (D9) / CPI-1209: the Booking ID column; rule and cell value live in utils/vietnam.js.
  showBookingIDColumn = () => vnShowBookingIDColumn(this.props.auth)
  // CPI-1226: why a booking was cancelled; book-api mirrors both values onto the booking row.
  showCancellationReasonColumn = () => {
    const { auth } = this.props;
    return isCountryVietnam(auth.company.countryCode);
  }
  showProjectColumn = () => {
    const { auth } = this.props;
    return isCountryVietnam(auth.company.countryCode);
  }
  // CPI-1209 (A33/A34): Pending Cancellation is a view of the cancellation request, not a status.
  showPendingCancellation = () => {
    const { auth } = this.props;
    return isCountryVietnam(auth.company.countryCode);
  }
  renderCancellationReason = (row) => {
    const label = cancellationCategoryLabel(row.srCancellationType);
    const translatedLabel = label
      ? this.props.t(label, { ns: TRANSLATION_FILES.translation })
      : '';
    return translatedLabel || '-';
  }
  handleChangeTab = (e, { name, value }) => {
    const currentTab = name || value;
    this.setState({
      currentTab,
      data: [],
      filteredProjects: [],
      offset: 0,
      count: 0,
      limit: 0,
    }, () => {
      if (this.props.isUnitOverview) {
        this.replaceQuery({
          tab: currentTab,
          section: 'bookings',
        }, true);
      } else {
        this.replaceQuery({
          tab: currentTab,
        }, true);
      }
    });
  }
  agingRanges = [
    {
      value: 'all',
      text: 'All',
      sortColumn: 'aging_summary.current_age',
    },
    {
      value: 'reserved_to_today',
      text: 'Reserved To Today',
      sortColumn: 'aging_summary.reserved_to_today_age',
    },
    {
      value: 'reserved_to_booked',
      text: 'Reserved To Booked',
      sortColumn: 'aging_summary.booked_age',
    },
    {
      value: 'reserved_to_sold',
      text: 'Reserved To Sold',
      sortColumn: 'aging_summary.reserved_to_sold_age',
    },
    {
      value: 'booked_to_today',
      text: 'Booked To Today',
      sortColumn: 'aging_summary.booked_to_today_age',
    },
    {
      value: 'booked_to_sold',
      text: 'Booked To Sold',
      sortColumn: 'aging_summary.sold_age',
    },
  ];
  loanStatuses = [
    {
      value: 'new',
      text: 'New',
      sortColumn: 'summary.current_age',
    },
    {
      value: 'pending_docs',
      text: 'Pending Docs',
      sortColumn: 'summary.current_age',
    },
    {
      value: 'pending_docs_submitted',
      text: 'Docs Submitted',
      sortColumn: 'summary.current_age',
    },
    {
      value: 'approved_lo_issued',
      text: 'LO Approved',
      sortColumn: 'summary.current_age',
    },
    {
      value: 'success_li_issued',
      text: 'LO Signed',
      sortColumn: 'summary.created_to_success_li_issued_age',
    },
    {
      value: 'reject_unqualified',
      text: 'Unqualified',
      sortColumn: 'summary.created_to_reject_unqualified_age',
    },
    {
      value: 'reject_bank',
      text: 'Bank Rejected',
      sortColumn: 'summary.created_to_reject_bank_age',
    },
    {
      value: 'reject_customer',
      text: 'Customer Rejected',
      sortColumn: 'summary.created_to_reject_customer_age',
    },
    {
      value: 'reject_cancelled',
      text: 'Customer Cancelled',
      sortColumn: 'summary.created_to_reject_cancelled_age',
    },
    {
      value: 'reject_lo_signed_other_bank',
      text: 'LO Signed With Another Bank',
      sortColumn: 'summary.created_to_reject_lo_signed_other_bank_age',
    },
    {
      value: 'reject_developer',
      text: 'Developer Cancelled',
      sortColumn: 'summary.created_to_reject_developer_age',
    },
  ];
  hasMPDetailsAccess = () => {
    const { auth } = this.props;
    return auth.isHeadquarters || auth.isBranchLeaderSupervisor;
  }
  cellCheckSorted = (column, isReversed = false) => {
    const { sortColumn, sortDirection } = decodeSearch(this.props.location.search);
    const { currentTab } = this.state;

    // API default sorted by descending if no sortColumn in URL
    if (!sortColumn) {
      if (
        (currentTab === 'all' && column === 'booking.created_at') ||
        (currentTab === 'aging_by_units' && this.agingRanges.some(age => age.sortColumn === column)) ||
        (currentTab === 'aging_by_bankers' && (this.loanStatuses.some(status => status.sortColumn === column) || column === 'summary.current_age')) ||
        (currentTab === 'aging_by_lawyers' && column === 'updated_at')
      ) {
        return 'descending';
      }
    }

    if (column === sortColumn) {
      if (isReversed) {
        return sortDirection === 'asc' ? 'descending' : 'ascending';
      }
      return sortDirection === 'asc' ? 'ascending' : 'descending';
    }
    return null;
  }
  handleCellSort = (column) => {
    const { sortColumn, sortDirection } = decodeSearch(this.props.location.search);
    const { currentTab } = this.state;

    let direction = 'asc';
    if (!sortColumn && currentTab === 'aging_by_lawyers' && column === 'updated_at') {
      direction = 'desc';
    } else if (column === sortColumn) {
      direction = sortDirection === 'asc' ? 'desc' : 'asc';
    }

    this.handleSortData(column, direction);
  }
  handleGetDaysSortColumn = () => {
    if (this.state.currentTab === 'aging_by_bankers') {
      if (this.loanStatuses.some(status => status.value === this.state.loanStatus)) {
        return this.loanStatuses.find(status => status.value === this.state.loanStatus).sortColumn;
      }
      return this.loanStatuses[0].sortColumn;
    }
    if (this.agingRanges.some(age => age.value === this.state.agingRange)) {
      return this.agingRanges.find(age => age.value === this.state.agingRange).sortColumn;
    }
    return this.agingRanges[0].sortColumn;
  }
  exportItemsAdmin = () => {
    if (this.hasAdminAccess() && this.state.currentTab !== 'aging_by_bankers') {
      const { location, projectUnitID } = this.props;
      let url = `${config.get('bookApiURL')}/reports/bookings/customer_details/`;
      if (location && location.search) {
        url += `${location.search}`;
      }
      if (projectUnitID) {
        url += `&projectUnitID=${projectUnitID}`;
      }
      return [
        {
          text: 'Excel\nwith\nCustomer\nDetails',
          icon: 'download',
          href: `${url}&fileType=excel`,
        },
        {
          text: 'Excel\n(primary)\nwith\nCustomer\nDetails',
          icon: 'download',
          href: `${url}&fileType=excel&primaryOnly=true`,
        },
        {
          text: 'CSV\nwith\nCustomer\nDetails',
          icon: 'download',
          href: `${url}&fileType=csv`,
        },
        {
          text: 'CSV\n(primary)\nwith\nCustomer\nDetails',
          icon: 'download',
          href: `${url}&fileType=csv&primaryOnly=true`,
        },
      ];
    }
    return [];
  }
  exportItemsPrimary = () => {
    if (this.state.currentTab !== 'aging_by_bankers') {
      return [
        {
          text: 'Excel\n(primary)',
          icon: 'download',
          href: this.exportURL('excel', true),
        },
        {
          text: 'CSV\n(primary)',
          icon: 'download',
          href: this.exportURL('csv', true),
        },
      ];
    }
    return [];
  }
  // The bookings Full Excel cap the API reports on GET /settings/, 0 while settings have not
  // loaded. The store wraps the settings object in a one-element array.
  bookingExportRowLimit = () => {
    const data = this.props.globalSettings && this.props.globalSettings.data;
    const setting = Array.isArray(data) ? data[0] : data;
    return (setting && setting.bookingExportRowLimit) || 0;
  }
  exportItemsManager = () => {
    const isMalaysia = this.props.auth.company && this.props.auth.company.countryCode === 'my';
    if (this.hasAccess() && this.state.currentTab !== 'aging_by_bankers') {
      const query = decodeSearch(this.props.location.search);
      query.page = 'all';
      const bookingExportRowLimit = this.bookingExportRowLimit();
      const exportItems = [
        {
          text: 'Full\nExcel',
          icon: 'download',
          href: `${config.get('bookApiURL')}/bookings/export/?${qs.stringify(query)}`,
          dataTarget: 'fullexcel',
          tooltip: bookingExportRowLimit
            ? this.props.t('Exports up to {{limit}} records', { limit: bookingExportRowLimit.toLocaleString(), ns: TRANSLATION_FILES.translation })
            : null,
        },
        {
          text: 'Updated Today',
          icon: 'download',
          href: `${config.get('bookApiURL')}/bookings/export/?page=all&updatedToday=true`,
          dataTarget: 'updatedtoday',
        },
        {
          isDivider: true,
        },
      ];
      if (this.state.currentTab === 'all' && isMalaysia) {
        exportItems.push(
          {
            text: 'Loan Approval',
            icon: 'download',
            href: `${config.get('bookApiURL')}/bookings/export/loan_approvals/?${qs.stringify(query)}`,
            dataTarget: 'loanapproval',
          },
          {
            text: 'Booking Notes',
            icon: 'download',
            href: `${config.get('bookApiURL')}/bookings/export/notes/?${qs.stringify(query)}`,
            dataTarget: 'bookingnotes',
          },
          {
            isDivider: true,
          },
        );
      }
      return exportItems;
    }
    return [];
  }
  isShowLoanReminderLetter(data = {}) {
    const criteria = this.state.currentTab === 'aging_by_units' &&
      data.project.printLoanReminderType !== '' &&
      (data.bookingStatus.id === 'booked' || data.bookingStatus.id === 'reserved') &&
      this.checkGroupAccess(this.props.auth.groups) &&
      data.currentAge >= 14 &&
      data.currentAge <= 42;

    return criteria;
  }
  isShowSpaReminderLetter(data = {}) {
    const criteria = this.state.currentTab === 'aging_by_units' &&
      data.project.printSPAType !== '' &&
      (data.bookingStatus.id === 'booked' || data.bookingStatus.id === 'reserved') &&
      this.checkGroupAccess(this.props.auth.groups) &&
      data.currentAge >= 28;

    return criteria;
  }
  isShowTerminationLetter(data = {}) {
    const criteria = this.state.currentTab === 'aging_by_units' &&
      data.project.printTerminationType !== '' &&
      data.bookingStatus.id === 'sold_spa_signed' &&
      this.checkGroupAccess(this.props.auth.groups) &&
      data.currentAge >= 21;

    return criteria;
  }
  checkGroupAccess = (groups) => {
    const roles = [
      { text: 'Headquarters', value: '10,6' },
      { text: 'Supervisor', value: '10,11,12,13' },
      { text: 'Sales Manager', value: '10,11,13' },
      { text: 'Sales Admin', value: '10,11' },
    ];
    const rolesArr = [];
    if (groups) {
      groups.forEach((g) => {
        rolesArr.push(g.id);
      });
      rolesArr.sort();
      const role = roles.find(g => g.value === String(rolesArr.toString()));
      if (role && role.text) {
        return role.text;
      }
    }
    return null;
  }
  hasLawyerSPASignedDate = (date) => {
    if (date) {
      if (date.length > 1 && date[1]) {
        return true;
      }
    }
    return false;
  }
  handlePrint = () => {
    Auth.currentSession();
  }
  statusDateSortItems = () => {
    const { bookingStatus } = this.state;
    let label = '';
    let column = '';
    switch (bookingStatus) {
      case 'cancelled_developer':
        label = 'Cancelled';
        column = 'l_cancelled_developer_at';
        break;
      case 'expired':
        label = 'Expired';
        column = 'l_expired_at';
        break;
      case 'booked':
        label = 'Booked';
        column = 'l_booked_at';
        break;
      case 'sold_spa_signed':
        label = 'Sold';
        column = 'l_sold_at';
        break;
      default:
        break;
    }
    return !this.props.projectUnitID && column ? [
      {
        text: `${label} Date Ascending`,
        icon: 'sort alphabet ascending',
        sortColumn: `booking.${column}`,
        sortDirection: 'asc',
      },
      {
        text: `${label} Date Descending`,
        icon: 'sort alphabet descending',
        sortColumn: `booking.${column}`,
        sortDirection: 'desc',
      },
    ] : [];
  }
  bookingNoteToMarkdown = (bNote) => {
    try {
      const hasNoSpaces = bNote.indexOf(' ') === -1;
      if (hasNoSpaces) {
        return decodeURIComponent(bNote.replace(/\+/g, ' '));
      }
      return decodeURIComponent(bNote);
    } catch (e) {
      return bNote;
    }
  };
  bookingNoteToEditorState = (bookingNote) => {
    const mdValue = this.bookingNoteToMarkdown(bookingNote);
    if (mdValue) {
      const rawData = markdownToDraft(mdValue, {
        preserveNewlines: true,
        blockStyles: {
          ins_open: 'UNDERLINE',
        },
        remarkableOptions: {
          enable: {
            inline: 'ins',
          },
        },
      });
      const contentState = convertFromRaw(rawData);
      const editorState = EditorState.createWithContent(contentState);
      return editorState;
    }
    return EditorState.createEmpty();
  }
  bookingNoteFormated = (bookingData) => {
    if (!bookingData) return '';
    if (!bookingData.latestBookingNote) return bookingData.remarkInternal; // deprecated old field
    // convert markdown to draft-js and then back to plaintext properly with custom formatings.
    const editorState = this.bookingNoteToEditorState(bookingData.latestBookingNote);
    const contentState = editorState.getCurrentContent();
    let plainText = contentState.getPlainText();
    const maxLength = 180;
    if (plainText && plainText.length > maxLength) {
      plainText = `${plainText.substring(0, maxLength)}...`;
    }
    return plainText;
  }
  hasBookingNote = (bookingData) => {
    if (bookingData && (bookingData.latestBookingNote || bookingData.remarkInternal)) return true;
    return false;
  }
  renderStatusDateFilter = () => {
    const { bookingStatus, loading, isMobile } = this.state;
    let filter = '';
    let filterFrom = '';
    let filterTo = '';
    let headerText = '';
    switch (bookingStatus) {
      case 'cancelled_developer':
        filter = 'cancelledDateRange';
        filterFrom = 'cancelledDateFrom';
        filterTo = 'cancelledDateTo';
        headerText = 'Cancelled Date Range';
        break;
      case 'expired':
        filter = 'expiredDateRange';
        filterFrom = 'expiredDateFrom';
        filterTo = 'expiredDateTo';
        headerText = 'Expired Date Range';
        break;
      case 'booked':
        filter = 'bookedDateRange';
        filterFrom = 'bookedDateFrom';
        filterTo = 'bookedDateTo';
        headerText = 'Booked Date Range';
        break;
      case 'sold_spa_signed':
        filter = 'soldDateRange';
        filterFrom = 'soldDateFrom';
        filterTo = 'soldDateTo';
        headerText = 'Sold Date Range';
        break;
      default:
        break;
    }
    return filter && !this.props.projectUnitID && (
      <Grid.Column
        className="filter tight-column"
        mobile={16}
        tablet={5}
        computer={5}
        style={{ paddingBottom: isMobile ? '1rem' : '0rem' }}
      >
        <BookingDatePicker
          filterName={filter}
          filterNameFrom={filterFrom}
          filterNameTo={filterTo}
          headerText={t(headerText, { ns: TRANSLATION_FILES.screens })}
          placeholder={t(`Select ${headerText}`, { ns: TRANSLATION_FILES.screens })}
          dateFrom={this.state[filterFrom]}
          dateTo={this.state[filterTo]}
          onChange={this.handleFilterOnChange}
          onClose={this.handleClearFilter}
          onResetRange={this.handleClearFilter}
          onSetRange={(from, to) => this.handleSetDateRange(filter, from, to)}
          value={this.state[filter]}
          disabled={loading}
          label={t(headerText, { ns: TRANSLATION_FILES.screens })}
        />
      </Grid.Column>
    );
  }
  renderAgingTabsMobile = () => {
    const { currentTab, tabss } = this.state;
    const { t } = this.props;
    return (
      <Dropdown
        className="uc-dropdown-show-all-items"
        fluid
        selection
        floating
        options={tabss.map(tab => ({
          key: tab.name,
          value: tab.name,
          text: titleCase(t(tab.text, { ns: namespaces[tab.name === 'all' ? 1 : 0] })),
        }))}
        value={currentTab}
        onChange={this.handleChangeTab}
      />
    );
  }
  renderDefaultClearFilter = () => {
    const { isMobile } = this.state;
    const { t } = this.props;
    return (
      (this.getAllFilterNames(false).some(filterName => this.state[filterName] &&
        this.state[filterName].length > 0) || this.state.search.length > 0) && (
        <Grid.Row style={{ paddingBottom: '0rem', paddingTop: isMobile ? '0rem' : '1rem' }}>
          <Grid.Column
            verticalAlign="middle"
          >
            <Button
              className="uc-clear-button"
              content={t('Clear all', { ns: TRANSLATION_FILES.translation })}
              onClick={() => this.handleClearFilter(...this.getAllFilterNames(false))}
            />
          </Grid.Column>
        </Grid.Row>)
    );
  }
  renderAccordionDefaultView = (searchAreas) => {
    const { projectUnitID, t } = this.props;
    const { currentTab, loading, loadingProjectSearch, activeAccordionIndex, isTablet, isMobile } = this.state;
    const isCurrentTabAll = currentTab === 'all';
    const isCurrentTabUnit = currentTab === 'aging_by_units';
    const isCurrentTabBanker = currentTab === 'aging_by_bankers';
    const isCurrentTabLawyer = currentTab === 'aging_by_lawyers';
    return (
      <Accordion fluid className="uc-accordion shadow-border" style={{ paddingBottom: !isMobile && activeAccordionIndex !== 0 ? '1.5rem' : '0.5rem' }}>
        <Accordion.Title
          style={{ paddingBottom: '1rem' }}
          active={activeAccordionIndex === 0}
          index={0}
        >
          <Grid>
            <Grid.Row columns="equal" style={{ paddingBottom: activeAccordionIndex === 0 ? '1rem' : '0rem' }}>
              <Grid.Column
                className="tight-column"
                tablet={5}
                computer={5}
              >
                <SearchIn
                  isLoading={loading}
                  onChange={this.handleFilterOnChange}
                  onSearchInChange={this.handleFilterOnChange}
                  onClear={this.handleClearFilter}
                  search={this.state.search}
                  searchIn={this.state.searchIn}
                  options={searchAreas}
                  isFullSize={!isCurrentTabBanker && !projectUnitID}
                  label={t('Keywords', { ns: TRANSLATION_FILES.screens })}
                />
              </Grid.Column>
              {
                !projectUnitID && (
                  <Grid.Column
                    className="filter tight-column"
                    tablet={5}
                    computer={5}
                  >
                    <div className="field">
                      <label
                        className="ui"
                        htmlFor="projectFilter"
                        style={{ fontWeight: 'bold', margin: '0 0 0.28571429rem 0', fontSize: '.92857143em', display: 'block' }}
                      >
                        {t('Projects', { ns: TRANSLATION_FILES.screens })}
                      </label>
                      <Dropdown
                        fluid
                        search
                        selection
                        floating
                        disabled={loading || loadingProjectSearch}
                        loading={loadingProjectSearch}
                        multiple={!isCurrentTabLawyer}
                        name="projectFilter"
                        onChange={this.handleFilterProjects}
                        options={this.state.projectOpts}
                        placeholder={t('Find Project')}
                        value={!isCurrentTabLawyer ? this.state.filteredProjects : this.state.filteredProjects[0] || ''}
                        noResultsMessage={t('No results found', { ns: TRANSLATION_FILES.translation })}
                      />
                    </div>
                  </Grid.Column>
                )
              }
              {
                isCurrentTabAll && (
                  <Grid.Column
                    className="filter tight-column"
                    tablet={5}
                    computer={5}
                  >
                    <BookingSelectListMultiple
                      filterName="bookingStatusMulti"
                      onChange={this.handleFilterOnChange}
                      onClose={this.handleClearFilter}
                      options={bookingStatusesAll(this.showPendingCancellation()).map(({ value, text }) => ({ value, text: t(text, { ns: TRANSLATION_FILES.constants }) }))}
                      placeholder={t('Booking Status')}
                      value={this.state.bookingStatusMulti}
                      disabled={loading}
                      label={t('Booking Status', { ns: TRANSLATION_FILES.screens })}
                    />
                  </Grid.Column>
                )
              }
              {
                isCurrentTabUnit && (
                  <Grid.Column
                    className="filter tight-column"
                    tablet={5}
                    computer={5}
                  >
                    <BookingSelectListMultiple
                      filterName="bookingStatusMulti"
                      onChange={this.handleFilterOnChange}
                      onClose={this.handleClearFilter}
                      options={bookingStatusesAll(this.showPendingCancellation()).map(({ value, text }) => ({ value, text: t(text, { ns: TRANSLATION_FILES.constants }) }))}
                      placeholder={t('Booking Status')}
                      value={this.state.bookingStatusMulti}
                      disabled={loading}
                      label={t('Booking Status', { ns: TRANSLATION_FILES.screens })}
                    />
                  </Grid.Column>
                )
              }
              {
                isCurrentTabBanker && (
                  <Grid.Column
                    className="filter tight-column"
                    tablet={5}
                    computer={5}
                  >
                    <BookingSelectListMultiple
                      filterName="loanStatus"
                      onChange={this.handleFilterOnChange}
                      onClose={this.handleClearFilter}
                      options={this.loanStatuses.map(({ value, text }) => ({ value, text: t(text, { ns: TRANSLATION_FILES.constants }) }))}
                      placeholder={t('Loan Status')}
                      value={this.state.loanStatus}
                      disabled={loading}
                      label={t('Loan Status', { ns: TRANSLATION_FILES.screens })}
                    />
                  </Grid.Column>
                )
              }
              {
                isCurrentTabLawyer && (
                  <Grid.Column
                    className="filter tight-column"
                    tablet={5}
                    computer={5}
                  >
                    <BookingSelectList
                      filterName="lawyerCaseType"
                      onChange={this.handleFilterOnChange}
                      onClose={this.handleClearFilter}
                      options={LAWYER_CASE_TYPES.map(({ value, text }) => ({ value, text: t(text, { ns: TRANSLATION_FILES.constants }) }))}
                      placeholder={t('Case Type')}
                      value={this.state.lawyerCaseType}
                      disabled={loading}
                      label={t('Case Type', { ns: TRANSLATION_FILES.screens })}
                    />
                  </Grid.Column>
                )
              }
              <Grid.Column width={1} style={{ paddingLeft: isTablet ? '0rem' : '0.7rem' }} textAlign="left">
                <Popup
                  size="tiny"
                  style={{ backgroundColor: '#596975' }}
                  basic
                  inverted
                  content={activeAccordionIndex === 0 ? t('Collapse', { ns: TRANSLATION_FILES.translation }) : t('Expand', { ns: TRANSLATION_FILES.translation })}
                  position="bottom center"
                  trigger={
                    <Button
                      icon
                      circular
                      onClick={e => this.handleAccordionClick(e, { index: activeAccordionIndex === 0 ? -1 : 0 })}
                      className={`uc-accordion-toggle-btn ${activeAccordionIndex === 0 ? 'rotated' : ''}`}
                    >
                      <Icon name="chevron down" />
                    </Button>
                  }
                />
              </Grid.Column>
            </Grid.Row>
            {activeAccordionIndex !== 0 && this.renderDefaultClearFilter()}
          </Grid>
        </Accordion.Title>
        <Transition visible={activeAccordionIndex === 0} animation="slide down" duration={200}>
          <Accordion.Content active={activeAccordionIndex === 0} style={{ paddingBottom: '2rem' }}>
            <Grid
              // className="filters booking"
              textAlign="left"
              verticalAlign="middle"
            >
              <Grid.Row style={{ paddingBottom: '0rem' }}>
                {
                  isCurrentTabAll && (
                    <Grid.Column
                      className="filter tight-column"
                      tablet={5}
                      computer={5}
                    >
                      <BookingSelectListMultiple
                        filterName="paymentStatus"
                        onChange={this.handleFilterOnChange}
                        onClose={this.handleClearFilter}
                        options={PAYMENT_STATUSES.map(({ value, text }) => ({ value, text: t(text, { ns: TRANSLATION_FILES.constants }) }))}
                        placeholder={t('Payment Status')}
                        value={this.state.paymentStatus}
                        disabled={loading}
                        label={t('Payment Status', { ns: TRANSLATION_FILES.screens })}
                      />
                    </Grid.Column>
                  )
                }
                {
                  isCurrentTabAll && (
                    <Grid.Column
                      className="filter tight-column"
                      tablet={5}
                      computer={5}
                    >
                      <BookingDatePicker
                        filterName="dateRange"
                        filterNameFrom="dateFrom"
                        filterNameTo="dateTo"
                        headerText={t('Created Date Range')}
                        placeholder={t('Select Created Date Range')}
                        dateFrom={this.state.dateFrom}
                        dateTo={this.state.dateTo}
                        onChange={this.handleFilterOnChange}
                        onClose={this.handleClearFilter}
                        onResetRange={this.handleClearFilter}
                        onSetRange={(from, to) => this.handleSetDateRange('dateRange', from, to)}
                        value={this.state.dateRange}
                        disabled={loading}
                        label={t('Created Date Range')}
                      />
                    </Grid.Column>
                  )
                }
                {this.renderStatusDateFilter()}
                {
                  isCurrentTabUnit && (
                    <Grid.Column
                      className="filter tight-column"
                      tablet={5}
                      computer={5}
                    >
                      <BookingSelectList
                        filterName="agingRange"
                        onChange={this.handleFilterOnChange}
                        onClose={this.handleClearFilter}
                        options={this.agingRanges.map(({ value, text }) => ({ value, text: t(text, { ns: TRANSLATION_FILES.constants }) }))}
                        placeholder={t('Aging Range')}
                        value={this.state.agingRange}
                        disabled={loading}
                        label={t('Aging Range', { ns: TRANSLATION_FILES.screens })}
                      />
                    </Grid.Column>
                  )
                }
                {
                  isCurrentTabLawyer && (
                    <Grid.Column
                      className="filter tight-column"
                      tablet={5}
                      computer={5}
                    >
                      <BookingSelectList
                        filterName="lawyerCaseStatus"
                        onChange={this.handleFilterOnChange}
                        onClose={this.handleClearFilter}
                        options={getLawyerCaseStatuses(this.state.lawyerCaseType).map(({ value, text }) => ({ value, text: t(text, { ns: TRANSLATION_FILES.constants }) }))}
                        placeholder={t('Case Status')}
                        value={this.state.lawyerCaseStatus}
                        disabled={loading}
                        label={t('Case Status', { ns: TRANSLATION_FILES.screens })}
                      />
                    </Grid.Column>
                  )
                }
                {
                  currentTab !== 'all' && (
                    <Grid.Column
                      className="filter tight-column"
                      tablet={5}
                      computer={5}
                    >
                      <BookingSelectList
                        filterName="agingDuration"
                        onChange={this.handleFilterOnChange}
                        onClose={this.handleClearFilter}
                        options={AGING_DATE_RANGE.map(({ value, text }) => ({ value, text: t(text, { ns: TRANSLATION_FILES.constants }) }))}
                        placeholder={t('Duration')}
                        value={this.state.agingDuration}
                        disabled={loading}
                        label={t('Duration', { ns: TRANSLATION_FILES.screens })}
                      />
                    </Grid.Column>
                  )
                }
              </Grid.Row>
              {this.renderDefaultClearFilter()}
            </Grid>
          </Accordion.Content>
        </Transition>
      </Accordion>
    );
  }
  renderAccordionMobileView = (searchAreas) => {
    const { projectUnitID, t } = this.props;
    const { currentTab, loading, loadingProjectSearch, activeAccordionIndex } = this.state;
    const isCurrentTabAll = currentTab === 'all';
    const isCurrentTabUnit = currentTab === 'aging_by_units';
    const isCurrentTabBanker = currentTab === 'aging_by_bankers';
    const isCurrentTabLawyer = currentTab === 'aging_by_lawyers';
    return (
      <Accordion fluid className="uc-accordion shadow-border">
        <Accordion.Title
          // style={{ paddingBottom: '1rem' }}
          active={activeAccordionIndex === 0}
          index={0}
        >
          <Grid>
            <Grid.Row>
              <Grid.Column
                style={{ paddingBottom: activeAccordionIndex !== 0 ? '1rem' : '0rem' }}
                width={16}
              >
                <SearchIn
                  isLoading={loading}
                  onChange={this.handleFilterOnChange}
                  onSearchInChange={this.handleFilterOnChange}
                  onClear={this.handleClearFilter}
                  search={this.state.search}
                  searchIn={this.state.searchIn}
                  options={searchAreas}
                  isFullSize={!isCurrentTabBanker && !projectUnitID}
                  label={t('Keywords', { ns: TRANSLATION_FILES.screens })}
                />
              </Grid.Column>
              {
                activeAccordionIndex !== 0 && <Grid.Column width={16} textAlign="center">
                  <Popup
                    size="tiny"
                    style={{ backgroundColor: '#596975' }}
                    basic
                    inverted
                    content={activeAccordionIndex === 0 ? t('Collapse') : t('Expand')}
                    position="bottom center"
                    trigger={
                      <Button
                        onClick={e => this.handleAccordionClick(e, { index: activeAccordionIndex === 0 ? -1 : 0 })}
                        className={'uc-accordion-toggle-btn'}
                      >
                        <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                          <span style={{ fontSize: '12px', fontWeight: '400' }}>{t('More')}</span>
                          <Icon style={{ fontSize: '12px', fontWeight: '400' }} name="chevron down" />
                        </div>
                      </Button>
                    }
                  />
                </Grid.Column>
              }
            </Grid.Row>
          </Grid>
        </Accordion.Title>
        <Transition visible={activeAccordionIndex === 0} animation="slide down" duration={200}>
          <Accordion.Content active={activeAccordionIndex === 0}>
            <Grid
              textAlign="left"
              verticalAlign="middle"
            >
              <Grid.Row style={{ paddingBottom: '0rem' }}>
                {
                  !projectUnitID && (
                    <Grid.Column
                      className="filter"
                      width={16}
                      style={{ paddingBottom: '1rem' }}
                    >
                      <div className="field">
                        <label
                          className="ui"
                          htmlFor="projectFilter"
                          style={{ fontWeight: 'bold', margin: '0 0 0.28571429rem 0', fontSize: '.92857143em', display: 'block' }}
                        >
                          {t('Projects', { ns: TRANSLATION_FILES.screens })}
                        </label>
                        <Dropdown
                          fluid
                          search
                          selection
                          floating
                          disabled={loading || loadingProjectSearch}
                          loading={loadingProjectSearch}
                          multiple={!isCurrentTabLawyer}
                          name="projectFilter"
                          onChange={this.handleFilterProjects}
                          options={this.state.projectOpts}
                          placeholder={t('Find Project')}
                          value={!isCurrentTabLawyer ? this.state.filteredProjects : this.state.filteredProjects[0] || ''}
                        />
                      </div>
                    </Grid.Column>
                  )
                }
                {
                  isCurrentTabAll && (
                    <Grid.Column
                      className="filter"
                      width={16}
                      style={{ paddingBottom: '1rem' }}
                    >
                      <BookingSelectListMultiple
                        filterName="bookingStatusMulti"
                        onChange={this.handleFilterOnChange}
                        onClose={this.handleClearFilter}
                        options={bookingStatusesAll(this.showPendingCancellation()).map(({ value, text }) => ({ value, text: t(text, { ns: TRANSLATION_FILES.constants }) }))}
                        placeholder={t('Booking Status')}
                        value={this.state.bookingStatusMulti}
                        disabled={loading}
                        label={t('Booking Status', { ns: TRANSLATION_FILES.screens })}
                      />
                    </Grid.Column>
                  )
                }
                {
                  isCurrentTabAll && (
                    <Grid.Column
                      className="filter"
                      width={16}
                      style={{ paddingBottom: '1rem' }}
                    >
                      <BookingSelectListMultiple
                        filterName="paymentStatus"
                        onChange={this.handleFilterOnChange}
                        onClose={this.handleClearFilter}
                        options={PAYMENT_STATUSES.map(({ value, text }) => ({ value, text: t(text, { ns: TRANSLATION_FILES.constants }) }))}
                        placeholder={t('Payment Status')}
                        value={this.state.paymentStatus}
                        disabled={loading}
                        label={t('Payment Status', { ns: TRANSLATION_FILES.screens })}
                      />
                    </Grid.Column>
                  )
                }
                {
                  isCurrentTabUnit && (
                    <Grid.Column
                      className="filter"
                      width={16}
                      style={{ paddingBottom: '1rem' }}
                    >
                      <BookingSelectListMultiple
                        filterName="bookingStatusMulti"
                        onChange={this.handleFilterOnChange}
                        onClose={this.handleClearFilter}
                        options={bookingStatusesAll(this.showPendingCancellation()).map(({ value, text }) => ({ value, text: t(text, { ns: TRANSLATION_FILES.constants }) }))}
                        placeholder={t('Booking Status')}
                        value={this.state.bookingStatusMulti}
                        disabled={loading}
                        label={t('Booking Status', { ns: TRANSLATION_FILES.screens })}
                      />
                    </Grid.Column>
                  )
                }
                {
                  isCurrentTabBanker && (
                    <Grid.Column
                      className="filter"
                      width={16}
                      style={{ paddingBottom: '1rem' }}
                    >
                      <BookingSelectListMultiple
                        filterName="loanStatus"
                        onChange={this.handleFilterOnChange}
                        onClose={this.handleClearFilter}
                        options={this.loanStatuses.map(({ value, text }) => ({ value, text: t(text, { ns: TRANSLATION_FILES.constants }) }))}
                        placeholder={t('Loan Status')}
                        value={this.state.loanStatus}
                        disabled={loading}
                        label={t('Loan Status', { ns: TRANSLATION_FILES.screens })}
                      />
                    </Grid.Column>
                  )
                }
                {
                  isCurrentTabLawyer && (
                    <Grid.Column
                      className="filter"
                      width={16}
                      style={{ paddingBottom: '1rem' }}
                    >
                      <BookingSelectList
                        filterName="lawyerCaseType"
                        onChange={this.handleFilterOnChange}
                        onClose={this.handleClearFilter}
                        options={LAWYER_CASE_TYPES.map(({ value, text }) => ({ value, text: t(text, { ns: TRANSLATION_FILES.constants }) }))}
                        placeholder={t('Case Type')}
                        value={this.state.lawyerCaseType}
                        disabled={loading}
                        label={t('Case Type', { ns: TRANSLATION_FILES.screens })}
                      />
                    </Grid.Column>
                  )
                }
                {
                  isCurrentTabAll && (
                    <Grid.Column
                      className="filter"
                      width={16}
                      style={{ paddingBottom: '1rem' }}
                    >
                      <BookingDatePicker
                        filterName="dateRange"
                        filterNameFrom="dateFrom"
                        filterNameTo="dateTo"
                        headerText={t('Created Date Range')}
                        placeholder={t('Select Created Date Range', { ns: TRANSLATION_FILES.screens })}
                        dateFrom={this.state.dateFrom}
                        dateTo={this.state.dateTo}
                        onChange={this.handleFilterOnChange}
                        onClose={this.handleClearFilter}
                        onResetRange={this.handleClearFilter}
                        onSetRange={(from, to) => this.handleSetDateRange('dateRange', from, to)}
                        value={this.state.dateRange}
                        disabled={loading}
                        label={t('Created Date Range', { ns: TRANSLATION_FILES.screens })}
                      />
                    </Grid.Column>
                  )
                }
                {this.renderStatusDateFilter()}
                {
                  isCurrentTabUnit && (
                    <Grid.Column
                      className="filter"
                      width={16}
                      style={{ paddingBottom: '1rem' }}
                    >
                      <BookingSelectList
                        filterName="agingRange"
                        onChange={this.handleFilterOnChange}
                        onClose={this.handleClearFilter}
                        options={this.agingRanges.map(({ value, text }) => ({ value, text: t(text, { ns: TRANSLATION_FILES.constants }) }))}
                        placeholder={t('Aging Range')}
                        value={this.state.agingRange}
                        disabled={loading}
                        label={t('Aging Range', { ns: TRANSLATION_FILES.screens })}
                      />
                    </Grid.Column>
                  )
                }
                {
                  isCurrentTabLawyer && (
                    <Grid.Column
                      className="filter"
                      width={16}
                      style={{ paddingBottom: '1rem' }}
                    >
                      <BookingSelectList
                        filterName="lawyerCaseStatus"
                        onChange={this.handleFilterOnChange}
                        onClose={this.handleClearFilter}
                        options={getLawyerCaseStatuses(this.state.lawyerCaseType).map(({ value, text }) => ({ value, text: t(text, { ns: TRANSLATION_FILES.constants }) }))}
                        placeholder={t('Case Status')}
                        value={this.state.lawyerCaseStatus}
                        disabled={loading}
                        label={t('Case Status', { ns: TRANSLATION_FILES.screens })}
                      />
                    </Grid.Column>
                  )
                }
                {
                  currentTab !== 'all' && (
                    <Grid.Column
                      className="filter"
                      width={16}
                      style={{ paddingBottom: '1rem' }}
                    >
                      <BookingSelectList
                        filterName="agingDuration"
                        onChange={this.handleFilterOnChange}
                        onClose={this.handleClearFilter}
                        options={AGING_DATE_RANGE.map(({ value, text }) => ({ value, text: t(text, { ns: TRANSLATION_FILES.constants }) }))}
                        placeholder={t('Duration')}
                        value={this.state.agingDuration}
                        disabled={loading}
                        label={t('Duration', { ns: TRANSLATION_FILES.screens })}
                      />
                    </Grid.Column>
                  )
                }
              </Grid.Row>
              {this.renderDefaultClearFilter()}
              {
                activeAccordionIndex === 0 &&
                  <Grid.Column width={16} style={{ paddingTop: '0rem' }} textAlign="center">
                    <Popup
                      size="tiny"
                      style={{ backgroundColor: '#596975' }}
                      basic
                      inverted
                      content={activeAccordionIndex === 0 ? t('Collapse') : t('Expand')}
                      position="bottom center"
                      trigger={
                        <Button
                          onClick={e => this.handleAccordionClick(e, { index: activeAccordionIndex === 0 ? -1 : 0 })}
                          className={'uc-accordion-toggle-btn'}
                        >
                          <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                            <span style={{ fontSize: '12px', fontWeight: '400' }}>{t('Less')}</span>
                            <Icon style={{ fontSize: '12px', fontWeight: '400' }} name="chevron up" />
                          </div>
                        </Button>
                      }
                    />
                  </Grid.Column>
              }
            </Grid>
          </Accordion.Content>
        </Transition>
      </Accordion>
    );
  }
  renderMenuTool = () => {
    const { projectUnitID, t } = this.props;
    const { currentTab, loading, loadingProjectSearch, isChanging, isMobile, isComputer, isTablet } = this.state;
    const isCurrentTabAll = currentTab === 'all';
    const isCurrentTabUnit = currentTab === 'aging_by_units';
    const isCurrentTabBanker = currentTab === 'aging_by_bankers';
    const isCurrentTabLawyer = currentTab === 'aging_by_lawyers';
    const searchAreas = isCurrentTabLawyer ? [
      { value: 'all', text: t('All', { ns: TRANSLATION_FILES.constants }) },
      { value: 'lawyer', text: t('Lawyer') },
      { value: 'firm', text: t('Law Firm') },
    ] : [
      { value: 'all', text: t('All', { ns: TRANSLATION_FILES.constants }) },
      { value: 'booking.assigned_ma_preferred_name', text: t('Assigned staff') },
      { value: isCurrentTabBanker ? 'affiliate.name' : 'booking.ma_created_by_preferred_name', text: isCurrentTabBanker ? t('Reserved by') : createdByLabel(this.props.auth, t, t('Reserved by')) },
      { value: isCurrentTabBanker ? 'company_branch.name' : 'booking.ma_user_affiliate_company_branch_short_name', text: t('Business Unit') },
      // { value: 'booking.affiliate_name', text: 'Agent' },
      // { value: 'booking.agency_name', text: 'Agency' },
    ];
    if (isCurrentTabBanker) {
      searchAreas.push(
        { value: 'bankers.name', text: t('Banker') },
        { value: 'banks.name,banks.short_name', text: t('Bank') },
      );
    }
    const statusTabs = bookingStatusesTabs(this.showPendingCancellation());
    return (
      <Grid columns="equal">
        {
          isCurrentTabAll && (
            <Grid.Row>
              <Grid.Column>
                {
                  isMobile ? (
                    <BookingStatusDropdown
                      options={statusTabs.map(status => ({
                        key: status.value,
                        value: status.value,
                        count: this.getStatusCount(status.value),
                        valueLabel: t(status.text, { ns: TRANSLATION_FILES.constants }),
                        className: status.className,
                      }))}
                      onChange={(e) => {
                        if (e === 'total') {
                          this.handleReplaceStatus();
                        } else {
                          this.handleReplaceStatus(e);
                        }
                      }}
                      value={this.state.bookingStatus === '' ? statusTabs[0].value : this.state.bookingStatus}
                    />
                  ) : (
                    <Grid
                      className="status"
                      columns="equal"
                      textAlign="left"
                      verticalAlign="bottom"
                    >
                      <Grid.Row style={{ paddingTop: 0 }}>
                        {
                          statusTabs.map((status, key) => (
                            <FixedBarStatus
                              key={key}
                              className={status.className}
                              status={status.value}
                              name={t(status.text, { ns: TRANSLATION_FILES.constants })}
                              count={this.getStatusCount(status.value)}
                              selected={this.getSelectedStatus(status.value)}
                              onClick={status.value === 'total' ? () => this.handleReplaceStatus() : this.handleReplaceStatus}
                            />
                          ))
                        }
                      </Grid.Row>
                    </Grid>
                  )
                }
              </Grid.Column>
            </Grid.Row>
          )
        }
        <Grid.Row>
          {isMobile ? (<Grid.Column width={16}>
            {this.renderAccordionMobileView(searchAreas)}
          </Grid.Column>) : this.renderAccordionDefaultView(searchAreas)}

        </Grid.Row>
      </Grid>
    );
  }
  renderStatusDateCell = (isHeader, data = {}) => {
    const { t } = this.props;
    const { bookingStatus } = this.state;
    let label = '';
    let date = '';
    switch (bookingStatus) {
      case 'cancelled_developer':
        label = 'Cancelled';
        date = data.lastCancelledDeveloperAt;
        break;
      case 'expired':
        label = 'Expired';
        date = data.lastExpiredAt;
        break;
      case 'booked':
        label = 'Booked';
        date = data.lastBookedAt;
        break;
      case 'sold_spa_signed':
        label = 'Sold';
        date = data.lastSoldAt;
        break;
      default:
        break;
    }
    if (isHeader) {
      return (
        <span>
          {t('Created')}
          {
            !this.props.projectUnitID && label && (
              <span>
                &nbsp;&amp;
                <br />
                {t(label, { ns: TRANSLATION_FILES.constants })}
              </span>
            )
          }
        </span>
      );
    }
    return !this.props.projectUnitID && date && (
      <small>
        <Timestamp
          timestamp={date}
          format="DD/M/YYYY"
        />
      </small>
    );
  }
  renderTableHeaders = (sortItems) => {
    const { projectUnitID, t } = this.props;
    const { currentTab } = this.state;
    const isCurrentTabAll = currentTab === 'all';
    const isCurrentTabUnit = currentTab === 'aging_by_units';
    const isCurrentTabBanker = currentTab === 'aging_by_bankers';
    const isCurrentTabLawyer = currentTab === 'aging_by_lawyers';
    return (
      <Table.Header className="mobile-hide">
        <Table.Row>
          {
            !isCurrentTabAll && (
              <Table.HeaderCell
                sorted={this.cellCheckSorted(sortItems[isCurrentTabLawyer ? 8 : 10].sortColumn, isCurrentTabLawyer)}
                onClick={() => this.handleCellSort(sortItems[isCurrentTabLawyer ? 8 : 10].sortColumn)}
              >{t('Days')}</Table.HeaderCell>
            )
          }
          <Table.HeaderCell
            sorted={this.cellCheckSorted(sortItems[0].sortColumn)}
            onClick={() => this.handleCellSort(sortItems[0].sortColumn)}
          >{this.renderStatusDateCell(true)}</Table.HeaderCell>
          {
            this.showProjectColumn() ? (
              <Table.HeaderCell className="mobile-hide">{t('Project', { ns: TRANSLATION_FILES.screens })}</Table.HeaderCell>
            ) : null
          }
          {
            !projectUnitID ? (
              <Table.HeaderCell
                sorted={this.cellCheckSorted(sortItems[2].sortColumn)}
                onClick={() => this.handleCellSort(sortItems[2].sortColumn)}
              >{t('Unit')}</Table.HeaderCell>
            ) : null
          }
          {
            this.showBookingIDColumn() ? (
              <Table.HeaderCell className="mobile-hide">{t('Booking ID', { ns: TRANSLATION_FILES.translation })}</Table.HeaderCell>
            ) : null
          }
          {
            isCurrentTabAll ? (
              <Table.HeaderCell className="mobile-hide">{t('Customer')}</Table.HeaderCell>
            ) : null
          }
          {
            !isCurrentTabLawyer && (
              <Table.HeaderCell
                sorted={this.cellCheckSorted(sortItems[6].sortColumn)}
                onClick={() => this.handleCellSort(sortItems[6].sortColumn)}
              >{isCurrentTabBanker ? t('Reserved by') : createdByLabel(this.props.auth, t, t('Reserved by'))}</Table.HeaderCell>
            )
          }
          {
            isCurrentTabLawyer && (
              <Table.HeaderCell
                sorted={this.cellCheckSorted(sortItems[10].sortColumn)}
                onClick={() => this.handleCellSort(sortItems[10].sortColumn)}
              >{t('Purchaser')}</Table.HeaderCell>
            )
          }
          {
            isCurrentTabLawyer && (
              <Table.HeaderCell
                sorted={this.cellCheckSorted(sortItems[6].sortColumn)}
                onClick={() => this.handleCellSort(sortItems[6].sortColumn)}
              >{t('Type')}</Table.HeaderCell>
            )
          }
          {
            isCurrentTabBanker && (
              <Table.HeaderCell
                sorted={this.cellCheckSorted(sortItems[12].sortColumn)}
                onClick={() => this.handleCellSort(sortItems[12].sortColumn)}
              >{t('Banker')}</Table.HeaderCell>
            )
          }
          {
            isCurrentTabLawyer && (
              <Table.HeaderCell
                sorted={isCurrentTabLawyer ? null : this.cellCheckSorted(sortItems[4].sortColumn)}
                onClick={isCurrentTabLawyer ? null : () => this.handleCellSort(sortItems[4].sortColumn)}
              >{t('Lawyer')}</Table.HeaderCell>
            )
          }
          {
            isCurrentTabBanker && (
              <Table.HeaderCell
                collapsing
                sorted={this.cellCheckSorted(sortItems[14].sortColumn)}
                onClick={() => this.handleCellSort(sortItems[14].sortColumn)}
              >{t('Bank')}</Table.HeaderCell>
            )
          }
          {
            !isCurrentTabLawyer && this.hasInternalDEAccess() ?
              <Table.HeaderCell
                sorted={this.cellCheckSorted(sortItems[8].sortColumn)}
                onClick={() => this.handleCellSort(sortItems[8].sortColumn)}
              >{t('Assigned staff')}</Table.HeaderCell>
            : null
          }
          <Table.HeaderCell
            collapsing
            sorted={this.cellCheckSorted(sortItems[4].sortColumn)}
            onClick={() => this.handleCellSort(sortItems[4].sortColumn)}
            className="uc-sticky-col uc-right"
          >{t('Status')}</Table.HeaderCell>
          {
            this.showCancellationReasonColumn() ? (
              <Table.HeaderCell className="mobile-hide">{t('Cancellation reason', { ns: TRANSLATION_FILES.translation })}</Table.HeaderCell>
            ) : null
          }
          {
            !(isCurrentTabBanker || isCurrentTabLawyer) && (
              <Table.HeaderCell collapsing className="uc-sticky-col uc-right">{t('Progress')}</Table.HeaderCell>
            )
          }
        </Table.Row>
      </Table.Header>
    );
  }
  renderProgressCell = (data) => {
    const { t } = this.props;
    const { systemData, projectArData, isComputer, isMobile } = this.state;
    const iconSize = !isMobile ? 18 : 20;
    const project = projectArData.find(p => p.id === data.project.id) || {};
    const isAutoReleaseTimerEnabled = this.checkAutoReleaseTimer(data, project);
    const createdAt = moment(data.createdAt);
    const systemTimer = systemData.arBookingExpMoreThanMinutes !== '' && systemData.arBookingExpMoreThanMinutes !== '0';
    const secondsBeforeExpired = systemTimer ? Number(systemData.arBookingExpMoreThanMinutes) * 60 : Number(project.arBookingExpMoreThanMinutes) * 60;
    const endAt = createdAt.clone().add(secondsBeforeExpired, 'seconds');
    const currentPercent = getProgressPercent(createdAt, Date.now(), endAt);
    const afterProjectSettingDate = moment(project.arBookingStartDate).diff(moment(createdAt)) <= 0;
    const enabledForBookingStartDate = !project.arBookingAllUnderReserved && project.arBookingStartDate && afterProjectSettingDate;
    const isOutsideAutoReleaseTimer = moment().isBefore(createdAt) || moment().isAfter(endAt);
    const autoReleaseIcon = (
      <img
        src={
          isAutoReleaseTimerEnabled && !isOutsideAutoReleaseTimer && (project.arBookingAllUnderReserved || enabledForBookingStartDate)
            ? (currentPercent < 80
                ? ClockYellowSvg
                : (currentPercent >= 80 && currentPercent < 100
                  ? ClockRedSvg
                  : ClockDisabledSvg))
            : ClockDisabledSvg
        }
        width={iconSize}
        alt="auto release"
      />
    );
    const noteIcon = (
      <img
        src={this.hasBookingNote(data) ? NotesSvg : NotesDisabledSvg}
        width={iconSize}
        alt="notes"
      />
    );
    const paymentIcon = (
      <img
        src={this.getPaymentIcon(data.paymentStatus.id)}
        width={iconSize}
        alt="payment"
      />
    );
    const loanIcon = (
      <img
        src={data.bankCaseCount > 0 ? LoanSvg : LoanDisabledSvg}
        width={iconSize}
        alt="loan"
      />
    );
    return (
      <div className="verticalAlign-mid" style={{ display: 'inline-flex', justifyContent: 'start', gap: !isMobile ? '16px' : '0px' }}>
        <InfoPopup
          touchAsClicked={!isComputer}
          trigger={
            !isMobile
              ? autoReleaseIcon
              : (
                <Button
                  className="uc-icon-button"
                  icon={autoReleaseIcon}
                />
              )
          }
          content={`${t('Auto Release')}: ${isAutoReleaseTimerEnabled && !isOutsideAutoReleaseTimer && (project.arBookingAllUnderReserved || enabledForBookingStartDate)
            ? (currentPercent === 100
                ? '--'
                : getRemainingTimeSimple(endAt))
            : t('None', { ns: TRANSLATION_FILES.constants })}`
          }
        />
        <InfoPopup
          touchAsClicked={!isComputer}
          trigger={
            !isMobile
              ? noteIcon
              : (
                <Button
                  className="uc-icon-button"
                  icon={noteIcon}
                />
              )
            }
          content={`${t('Note')}: ${this.hasBookingNote(data) ? this.bookingNoteFormated(data) : '--'}`}
        />
        {
          data.paymentStatus && (
            <InfoPopup
              touchAsClicked={!isComputer}
              trigger={
                !isMobile
                  ? paymentIcon
                  : (
                    <Button
                      className="uc-icon-button"
                      icon={paymentIcon}
                    />
                  )
              }
              content={`${t('Payment')}: ${t(data.paymentStatus.name, { ns: TRANSLATION_FILES.constants })}`}
            />
          )
        }
        {/* TODO: comment first waiting for updated api calls+confirmation by backend team */}
        {/* <InfoPopup
          touchAsClicked={!isComputer}
          trigger={
            <img
              src={data.lawyer.spaLawyer || data.lawyer.laLawyer ? LegalSvg : LegalDisabledSvg}
              width={iconSize}
              alt="lawyer"
            />
          }
          content={data.lawyer.spaLawyer || data.lawyer.laLawyer ?
            <div style={{ display: 'inline-flex', flexDirection: 'column', rowGap: '0.5em' }}>
              <List.Item key={0}>{`SPA: ${data.lawyer.spaLawyer ? data.lawyer.spaLawyer.name : '--'}`}</List.Item>
              <List.Item key={1}>{`LA: ${data.lawyer.laLawyer ? data.lawyer.laLawyer.name : '--'}`}</List.Item>
            </div> : 'Lawyer: Not assigned'}
        /> */}
        <InfoPopup
          touchAsClicked={!isComputer}
          trigger={
            !isMobile
              ? loanIcon
              : (
                <Button
                  className="uc-icon-button"
                  icon={loanIcon}
                />
              )
          }
          content={
            data.bankCaseCount > 0 && data.bankCasesStatuses ?
              <div style={{ display: 'inline-flex', flexDirection: 'column', rowGap: '0.5em' }}>
                <span>{t('Loan')}:</span>
                {
                  data.bankCasesStatuses.map((bcs, i) => (
                    <List.Item key={i}><Icon name="circle" color={this.getBankCaseStatusColor(bcs.status) || ''} /> {bcs.bankShortName}</List.Item>
                  ))
                }
              </div> :
              `${t('Loan')}: ${t('Not assigned')}`
          }
        />
      </div>
    );
  }
  renderTableRow = (data, idx) => {
    const {
      currentTab,
      mpUserLoading,
      mpUserDetails,
      isMobile,
      isComputer,
    } = this.state;
    const { t } = this.props;

    const prepData = {
      id: '',
      code: '',
      name: '',
      currentAge: 0,
      createdAt: '',
      statusID: '',
      status: '',
      statusName: '',
      origin: '',
      buyerProfileID: '',
      booking_id: '',
      aging_days: 0,
      created_at: '',
      bookingCustomer: null,
      bookingStatus: null,
      paymentStatus: { id: '', name: '' },
      ...data,
    };
    prepData.projectUnit = { isBumi: false, reference: '', ...((data && data.projectUnit) || {}) };
    prepData.project = { shortName: '', name: '', ...((data && data.project) || {}) };
    prepData.paymentStatus = { id: '', name: '', ...((data && data.paymentStatus) || {}) };

    // TODO: comment first waiting for updated api calls+confirmation by backend team
    // const secondaryPurchasers = currentTab === 'all' && data.bookingCustomers
    //   ? data.bookingCustomers.filter(c => c.id !== data.bookingCustomer.id).map(c => c.name)
    //   : [];
    const secondaryPurchasers = 0;
    const isCurrentTabAll = currentTab === 'all';
    const isCurrentTabUnit = currentTab === 'aging_by_units';
    const isCurrentTabBanker = currentTab === 'aging_by_bankers';
    const isCurrentTabLawyer = currentTab === 'aging_by_lawyers';
    const isPendingCancellation = this.showPendingCancellation() && isBookingPendingCancellation(prepData);
    const statusTag = isCurrentTabBanker ?
      (prepData ?
        (() => {
          const bankStatus = BANK_CASE_STATUSES.find(e => e.value === prepData.status);
          return bankStatus ? <StatusFlag text={t(prepData.statusName, { ns: TRANSLATION_FILES.constants })} value={bankStatus.color} /> : null;
        })() : null) :
        isPendingCancellation ?
          <StatusFlag text={t('Pending Cancellation', { ns: TRANSLATION_FILES.constants })} value="opportunity-pending_cancellation" /> :
        prepData.bookingStatus ?
          <StatusFlag text={t(prepData.bookingStatus.name, { ns: TRANSLATION_FILES.constants })} value={prepData.bookingStatus.id} /> : null;
    const bookingHaveAdditionalTags = !isCurrentTabLawyer ?
      prepData.projectUnit.isBumi ||
      prepData.origin.includes('marketplace') ||
      prepData.buyerProfileID !== '' : false;

    if (isCurrentTabLawyer) {
      const statusOption = LAWYER_ALL_STATUSES.find(s => s.value === prepData.status);
      let status = '';
      if (statusOption) {
        status = t(statusOption.text, { ns: TRANSLATION_FILES.constants });
      }
      return (
        <Table.Row
          key={idx}
          className={this.getRowClassName(prepData.status)}
          onClick={isMobile ? () => this.context.router.push(`/bookings/${prepData.booking_id}/`) : null}
        >
          <Table.Cell collapsing className="days">
            <span className="mobile-hide">
              <Header
                color={this.getAgingColor(data.aging_days || 0)}
                content={data.aging_days || 0}
              />
            </span>
            <span className="computer-hide">
              <Link to={`/bookings/${data.booking_id}/`}>
                {(data.purchaser && data.purchaser.name) || ''}
              </Link>
            </span>
          </Table.Cell>
          <Table.Cell className="computer-hide" style={{ marginTop: '0.45em' }}>
            {statusOption && (
              <StatusFlag text={status} value={statusOption.color} />
            )}
          </Table.Cell>
          <Table.Cell collapsing className="mobile-hide">
            <span>
              <Timestamp
                timestamp={data.created_at}
                format="DD/M/YYYY"
              />
            </span>
          </Table.Cell>
          {
            !this.props.projectUnitID ? (
              <Table.Cell>
                <div className="mobile-hide">
                  <Link title={data.code} to={`/bookings/${data.booking_id}/`}>
                    {data.property && data.property.unit_no}, {data.property && data.property.project_name}
                  </Link>
                </div>
                <div className="computer-hide" style={{ display: 'flex', flexDirection: 'column', gap: '0.7em', marginTop: '0.3em' }}>
                  <span>
                    <div style={{ display: 'inline-flex', gap: '0.5em', alignItems: 'start' }}>
                      <img style={{ marginTop: '0.3em' }} src={BuildingSvg} alt="calendar" width={20} />
                      {data.property && data.property.unit_no} • {data.property && data.property.project_name}
                    </div>
                  </span>
                  <div style={{ display: 'inline-flex', gap: '0.5em' }}>
                    <img src={CalendarSvg} alt="calendar" width={16} />
                    <Timestamp
                      timestamp={data.createdAt}
                      format="DD/M/YYYY"
                    />
                  </div>
                  <div>
                    <span>
                      {t('Lawyer')}:&nbsp;&nbsp;
                      {
                        data.lawyer ? data.lawyer.name : '-'
                      }
                    </span>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <StatusFlag text={data.type} value="status-ghost" />
                    <Header
                      floated="right"
                      color={this.getAgingColor(data.aging_days)}
                      content={data.aging_days}
                    />
                  </div>
                </div>

              </Table.Cell>
            ) : null
          }
          <Table.Cell className="mobile-hide">
            <span>
              {data.purchaser && data.purchaser.name}
            </span>
          </Table.Cell>
          <Table.Cell collapsing className="mobile-hide">
            <span>
              {data.type}
            </span>
          </Table.Cell>
          <Table.Cell className="mobile-hide">
            <span>
              {data.lawyer && data.lawyer.name}
            </span>
          </Table.Cell>
          <Table.Cell collapsing className="mobile-hide">
            {statusOption && (
              <StatusFlag text={status} value={statusOption.color} />
            )}
          </Table.Cell>
        </Table.Row>
      );
    }
    return (
      <Table.Row
        key={idx}
        className={this.getRowClassName(prepData.statusID)}
        {...this.getDataTarget(idx)}
        {...this.getDatasetAttributes('bookingid', prepData.id)}
        {...this.getDatasetAttributes('unitno', prepData.projectUnit.reference)}
        {...this.getDatasetAttributes('projectname', prepData.project.shortName)}
        {...this.getDatasetAttributes('purchasername', isCurrentTabBanker ? prepData.name : prepData.bookingCustomer ? prepData.bookingCustomer.name : '')}
        onClick={isMobile ? () => this.context.router.push(`/bookings/${prepData.id}/`) : null}
      >
        {
          (!isMobile && currentTab !== 'all') && (
            <Table.Cell className="days">
              <span>
                <Header
                  color={this.getAgingColor(prepData.currentAge)}
                  content={prepData.currentAge}
                />
              </span>
            </Table.Cell>
          )
        }
        <Table.Cell>
          <span className="mobile-hide">
            <Timestamp
              timestamp={prepData.createdAt}
              format="DD/M/YYYY"
            />
            <br />
            {this.renderStatusDateCell(false, prepData)}
          </span>
          {
            <span className="computer-hide">
              <Link to={`/bookings/${prepData.id}/`}>
                {isCurrentTabBanker ? prepData.name : prepData.bookingCustomer ? prepData.bookingCustomer.name : ''}
              </Link>
            </span>
          }
        </Table.Cell>
        {
          this.showProjectColumn() ? (
            <Table.Cell className="mobile-hide">{prepData.project.name || '-'}</Table.Cell>
          ) : null
        }
        {
          isMobile && (
            <Table.Cell style={{ marginTop: '0.45em' }}>
              {statusTag}
            </Table.Cell>
          )
        }
        {
          !this.props.projectUnitID ? (
            <Table.Cell>
              <div className="mobile-hide">
                <Link style={{ fontSize: 14 }} title={prepData.code} to={`/bookings/${prepData.id}/`}>
                  {prepData.projectUnit.reference}
                </Link>
                <br />
                <span className="uc-table-cell-subtitle1">{prepData.project.name}</span>
                <br />
                <div style={{ display: 'flex', gap: '0.5em' }}>
                  {/* CPI-1269: Project > Unit's wording for the same is_bumi flag. */}
                  {prepData.projectUnit.isBumi && <Label className="uc-label-ghost" size="mini">{unitQuotaChipLabel(this.props.auth, t)}</Label>}
                  {prepData.origin.includes('marketplace') && <Label className="uc-label-ghost" size="mini">{prepData.origin.includes('_') ? t('Showroom for Buyer') : t('Marketplace')}</Label>}
                  {prepData.buyerProfileID !== '' && <Label className="uc-label-ghost" size="mini">{t('Buyer')}</Label>}
                </div>
              </div>
              <div className="computer-hide" style={{ display: 'flex', flexDirection: 'column', gap: '0.7em', marginTop: '0.3em' }}>
                <span>
                  <div style={{ display: 'inline-flex', gap: '0.5em', alignItems: 'start' }}>
                    <img src={BuildingSvg} alt="Calendar" width={20} />
                    {prepData.projectUnit.reference} • {prepData.project.name}
                  </div>
                </span>
                <div style={{ display: 'inline-flex', gap: '0.5em' }}>
                  <img src={CalendarSvg} alt="Calendar" width={16} />
                  <Timestamp
                    timestamp={prepData.createdAt}
                    format="DD/M/YYYY"
                  />
                </div>
                {
                  isCurrentTabUnit && (
                    <div>
                      {
                        this.hasInternalDEAccess() ? (
                          <span>
                            {t('Assigned staff')}:&nbsp;&nbsp;
                            {
                              data.assignedMaPreferredName ?
                              data.assignedMaPreferredName : '-'
                            }
                          </span>
                        ) : null
                      }
                    </div>
                  )
                }
                {
                  isCurrentTabBanker && (
                    <div style={{ display: 'inline-flex', direction: 'row', alignItems: 'center', gap: '0.5em' }}>
                      <span>
                        {t('Banker')}:&nbsp;&nbsp;
                        {
                          // show logo if banker is direct to bank and bank logo exist
                          data.bankerDirectToBank && data.bankLogoSrc ? (
                            <Image src={data.bankLogoSrc} style={{ maxHeight: '20px', display: 'inline-block' }} />
                          ) : data.banker
                        }
                      </span>
                      <StatusFlag text={data.bankShortName} value="status-info-dim" />
                    </div>
                  )
                }
                {
                  isCurrentTabBanker && (
                    <div>
                      <span>
                        {t('Reserved by')}:&nbsp;&nbsp;
                        {data.createdBy}
                      </span>
                      {
                        !bookingHaveAdditionalTags && <Header
                          floated="right"
                          color={this.getAgingColor(data.currentAge)}
                          content={data.currentAge}
                        />
                      }
                    </div>
                  )
                }
                {
                  bookingHaveAdditionalTags && (
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                      <div style={{ display: 'flex', gap: '0.5em', marginTop: '0.2em' }}>
                        {/* CPI-1269: Project > Unit's wording for the same is_bumi flag. */}
                        {data.projectUnit.isBumi && <Label className="uc-label-ghost" size="medium" style={{ paddingTop: '4px', paddingBottom: '4px' }}>{unitQuotaChipLabel(this.props.auth, t)}</Label>}
                        {data.origin && data.origin.includes('marketplace') && <Label className="uc-label-ghost" size="medium" style={{ paddingTop: '4px', paddingBottom: '4px' }}>{data.origin.includes('_') ? t('Showroom for Buyer') : t('Marketplace')}</Label>}
                        {data.buyerProfileID && data.buyerProfileID !== '' && <Label className="uc-label-ghost" size="medium" style={{ paddingTop: '4px', paddingBottom: '4px' }}>{t('Buyer')}</Label>}
                      </div>
                      {
                        !['all', 'aging_by_units'].includes(currentTab) && <Header
                          floated="right"
                          color={this.getAgingColor(data.currentAge)}
                          content={data.currentAge}
                        />
                      }
                    </div>
                  )
                }
              </div>
            </Table.Cell>
          ) : null
        }
        {
          this.showBookingIDColumn() ? (
            <Table.Cell className="mobile-hide">{bookingIDCellValue(prepData)}</Table.Cell>
          ) : null
        }
        {
          currentTab === 'all' ? (
            <Table.Cell className="mobile-hide">
              {/* TODO: temp hide the customer icon */}
              {/* <div style={{ display: 'inline-flex', alignItems: 'center' }}>
                <InfoPopup
                  touchAsClicked={!isComputer}
                  disabled={secondaryPurchasers.length === 0}
                  trigger={
                    <div style={{ position: 'relative', display: 'inline-block' }}>
                      <img src={UserSvg} alt="Customer" width={16} style={{ position: 'relative', zIndex: 2 }} />
                      {
                        secondaryPurchasers.length > 0 && (
                          <Label
                            size="mini"
                            style={{
                              position: 'absolute',
                              top: 0,
                              left: 5, // adjust based on image width
                              transform: 'translate(0%, -50%)',
                              borderRadius: '999px', // pill shape
                              padding: '0.3em 0.6em',
                              backgroundColor: '#E5FAF2',
                              color: '#50B793',
                              zIndex: 1,
                              cursor: 'default',
                            }}
                          >
                            +{secondaryPurchasers.length}
                          </Label>
                        )
                      }
                    </div>
                  }
                  content={
                    secondaryPurchasers.length > 0 && (
                      <div style={{ display: 'inline-flex', flexDirection: 'column' }}>
                        {
                          secondaryPurchasers.map((p, pI) => <span key={pI}>{titleCase(p)}</span>)
                        }
                      </div>
                    )
                  }
                />
                <span style={{ marginLeft: secondaryPurchasers.length > 0 ? '1em' : '0.5em' }}>
                  <Link to={`/bookings/${data.id}/`}>
                    {data.bookingCustomer && data.bookingCustomer.name}
                  </Link>
                </span>
              </div> */}
              <span>
                <Link to={`/bookings/${data.id}/`}>
                  {data.bookingCustomer && data.bookingCustomer.name}
                </Link>
              </span>
            </Table.Cell>
          ) : null
        }
        {
          !isMobile && (
            <Table.Cell>
              <span>
                {
                  data.origin && data.origin.includes('marketplace') && this.hasMPDetailsAccess() ? (
                    data.origin.includes('_') ?
                      <Popup
                        on="click"
                        trigger={
                          <a>
                            {data.maCreatedByPreferredName}
                          </a>
                      }
                        size="mini"
                        inverted
                        position="bottom right"
                        disabled
                        flowing
                      >
                        {
                        data.bookingCustomer ? (
                          <span style={{ fontSize: '15px' }}>
                            <div>{`${t('Name')}: ${data.bookingCustomer.name}`}</div>
                            {
                              data.bookingCustomer.email ?
                                <div>{`${t('Email')}: ${data.bookingCustomer.email}`}</div> :
                              null
                            }
                            <div>{`${t('Mobile')}: ${data.bookingCustomer.mobilePrefix}${data.bookingCustomer.mobile}`}</div>
                          </span>
                        ) : null
                      }
                      </Popup> :
                      <Popup
                        on="click"
                        trigger={
                          <a>
                            {data.maCreatedByPreferredName}
                          </a>
                      }
                        onOpen={() => {
                          this.fetchMarketplaceUserDetails(data.maUserID);
                        }}
                        size="mini"
                        inverted
                        position="bottom right"
                        disabled
                        flowing
                      >
                        {
                        mpUserLoading ? (
                          <Loader active inline="centered">{t('Loading', { ns: TRANSLATION_FILES.translation })}</Loader>
                        ) : (
                          <span style={{ fontSize: '15px' }}>
                            <div>{`${t('Name')}: ${mpUserDetails.fullName}`}</div>
                            <div>{`${t('Email')}: ${mpUserDetails.email}`}</div>
                            <div>{`${t('Mobile')}: ${mpUserDetails.mobilePrefix}${mpUserDetails.mobile}`}</div>
                            {
                              mpUserDetails.agencyName ? (
                                <div>{`${t('Agency Name')}: ${mpUserDetails.agencyName}`}</div>
                              ) : null
                            }
                            {
                              mpUserDetails.registrationNumber ? (
                                <div>{`${t('Registration Number')}: ${mpUserDetails.registrationNumber}`}</div>
                              ) : null
                            }
                          </span>
                        )
                      }
                      </Popup>
                  ) : this.hasStaffAccess() ?
                    <Link to={`/users/${currentTab === 'aging_by_bankers' ? data.createdByID : data.maUserAffiliateID}/`}>
                      {currentTab === 'aging_by_bankers' ? data.createdBy : data.maCreatedByPreferredName}
                    </Link>
                    : (currentTab === 'aging_by_bankers' ? data.createdBy : data.maCreatedByPreferredName)
                }

                {currentTab !== 'aging_by_bankers' ?
                  <small>
                    <br />{data.origin && data.origin.includes('marketplace_') ? t('Buyer') : data.maUserAffiliateCompanyBranchShortName}
                  </small>
                  : ''
                }
              </span>
            </Table.Cell>
          )
        }
        {
          this.props.projectUnitID && currentTab === 'aging_by_bankers' ? (
            <Table.Cell collapsing>
              <span className="mobile-hide">
                <Link to={`/bookings/${data.id}/`}>
                  {data.code}
                </Link>
              </span>
              <span className="computer-hide">
                {data.code}
              </span>
            </Table.Cell>
          ) : null
        }
        {
          (!isMobile && currentTab === 'aging_by_bankers') && (
            <Table.Cell collapsing>
              <span>
                {
                  // show logo if banker is direct to bank and bank logo exist
                  data.bankerDirectToBank && data.bankLogoSrc ? (
                    <Image src={data.bankLogoSrc} style={{ maxHeight: '20px', display: 'inline-block' }} />
                  ) : data.banker
                }
              </span>
            </Table.Cell>
          )
        }
        {
          (!isMobile && currentTab === 'aging_by_bankers') && (
            <Table.Cell collapsing>
              <span>
                {data.bankShortName}
              </span>
            </Table.Cell>
          )
        }
        {
          !isMobile && this.hasInternalDEAccess() ? (
            <Table.Cell>
              <span>
                {
                  data.assignedMaPreferredName ?
                  data.assignedMaPreferredName : '-'
                }
              </span>
            </Table.Cell>
          ) : null
        }
        {
          !isMobile && (
            <Table.Cell collapsing className="uc-sticky-col uc-right">
              {statusTag}
            </Table.Cell>
          )
        }
        {
          this.showCancellationReasonColumn() ? (
            <Table.Cell className="mobile-hide">{this.renderCancellationReason(prepData)}</Table.Cell>
          ) : null
        }
        {
          isMobile ? (
            (isCurrentTabAll || isCurrentTabUnit) && (
              <Table.Cell style={{ marginTop: '0.5em' }}>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'middle',
                    justifyContent: 'space-between',
                    width: '100%',
                  }}
                >
                  {this.renderProgressCell(prepData)}
                  {currentTab !== 'all' && (
                    <Header
                      style={{
                        marginTop: 0,
                        marginRight: '0.5em',
                        lineHeight: '1.5',
                        alignSelf: 'center',
                      }}
                      color={this.getAgingColor(prepData.currentAge)}
                      content={prepData.currentAge}
                    />
                  )}
                </div>
              </Table.Cell>
            )
          ) : (isCurrentTabAll || isCurrentTabUnit) && (
            <Table.Cell className="uc-sticky-col uc-right">
              {this.renderProgressCell(prepData)}
            </Table.Cell>
          )
        }
      </Table.Row>
    );
  }
  render() {
    if (this.props.hideBookingList && this.state.data.length < 1) {
      return <Grid />;
    }
    const { currentTab, loading, data, tabss, isMobile, isComputer } = this.state;
    const { t } = this.props;
    const sortItems = currentTab === 'aging_by_lawyers' ? [
      {
        text: 'Date Ascending',
        icon: 'sort alphabet ascending',
        sortColumn: 'created_at',
        sortDirection: 'asc',
      },
      {
        text: 'Date Descending',
        icon: 'sort alphabet descending',
        sortColumn: 'created_at',
        sortDirection: 'desc',
      },
      {
        text: 'Unit Ascending',
        icon: 'sort alphabet ascending',
        sortColumn: 'property.unit_no.keyword',
        sortDirection: 'asc',
      },
      {
        text: 'Unit Descending',
        icon: 'sort alphabet descending',
        sortColumn: 'property.unit_no.keyword',
        sortDirection: 'desc',
      },
      {
        text: 'Status Ascending',
        icon: 'sort alphabet ascending',
        sortColumn: 'status.keyword',
        sortDirection: 'asc',
      },
      {
        text: 'Status Descending',
        icon: 'sort alphabet descending',
        sortColumn: 'status.keyword',
        sortDirection: 'desc',
      },
      {
        text: 'Type Ascending',
        icon: 'sort alphabet ascending',
        sortColumn: 'type.keyword',
        sortDirection: 'asc',
      },
      {
        text: 'Type Descending',
        icon: 'sort alphabet descending',
        sortColumn: 'type.keyword',
        sortDirection: 'desc',
      },
      {
        text: 'Days Ascending',
        icon: 'sort alphabet ascending',
        sortColumn: 'updated_at',
        sortDirection: 'asc',
      },
      {
        text: 'Days Descending',
        icon: 'sort alphabet descending',
        sortColumn: 'updated_at',
        sortDirection: 'desc',
      },
      {
        text: 'Purchaser Ascending',
        icon: 'sort alphabet ascending',
        sortColumn: 'purchaser.name.keyword',
        sortDirection: 'asc',
      },
      {
        text: 'Purchaser Descending',
        icon: 'sort alphabet descending',
        sortColumn: 'purchaser.name.keyword',
        sortDirection: 'desc',
      },
    ] : [
      {
        text: 'Created Date Ascending',
        icon: 'sort alphabet ascending',
        sortColumn: currentTab === 'aging_by_bankers' ? 'bank_case.created_at' : 'booking.created_at',
        sortDirection: 'asc',
      },
      {
        text: 'Created Date Descending',
        icon: 'sort alphabet descending',
        sortColumn: currentTab === 'aging_by_bankers' ? 'bank_case.created_at' : 'booking.created_at',
        sortDirection: 'desc',
      },
      {
        text: 'Unit Ascending',
        icon: 'sort alphabet ascending',
        sortColumn: currentTab === 'aging_by_bankers' ? 'bank_case.reference_no' : 'project_unit.reference',
        sortDirection: 'asc',
      },
      {
        text: 'Unit Descending',
        icon: 'sort alphabet descending',
        sortColumn: currentTab === 'aging_by_bankers' ? 'bank_case.reference_no' : 'project_unit.reference',
        sortDirection: 'desc',
      },
      {
        text: 'Status Ascending',
        icon: 'sort alphabet ascending',
        sortColumn: currentTab === 'aging_by_bankers' ? 'bank_case.status' : 'booking_status.name',
        sortDirection: 'asc',
      },
      {
        text: 'Status Descending',
        icon: 'sort alphabet descending',
        sortColumn: currentTab === 'aging_by_bankers' ? 'bank_case.status' : 'booking_status.name',
        sortDirection: 'desc',
      },
      {
        text: 'Reserved By Ascending',
        icon: 'sort alphabet ascending',
        sortColumn: currentTab === 'aging_by_bankers' ? 'affiliate.name' : 'booking.ma_created_by_preferred_name',
        sortDirection: 'asc',
      },
      {
        text: 'Reserved By Descending',
        icon: 'sort alphabet descending',
        sortColumn: currentTab === 'aging_by_bankers' ? 'affiliate.name' : 'booking.ma_created_by_preferred_name',
        sortDirection: 'desc',
      },
      {
        text: 'Assigned Staff Ascending',
        icon: 'sort alphabet ascending',
        sortColumn: 'booking.assigned_ma_preferred_name',
        sortDirection: 'asc',
      },
      {
        text: 'Assigned Staff Descending',
        icon: 'sort alphabet descending',
        sortColumn: 'booking.assigned_ma_preferred_name',
        sortDirection: 'desc',
      },
      {
        text: 'Days Ascending',
        icon: 'sort alphabet ascending',
        sortColumn: this.handleGetDaysSortColumn(),
        sortDirection: 'asc',
      },
      {
        text: 'Days Descending',
        icon: 'sort alphabet descending',
        sortColumn: this.handleGetDaysSortColumn(),
        sortDirection: 'desc',
      },
      {
        text: 'Banker Ascending',
        icon: 'sort alphabet ascending',
        sortColumn: 'bankers.name',
        sortDirection: 'asc',
      },
      {
        text: 'Banker Descending',
        icon: 'sort alphabet descending',
        sortColumn: 'bankers.name',
        sortDirection: 'desc',
      },
      {
        text: 'Bank Ascending',
        icon: 'sort alphabet ascending',
        sortColumn: 'banks.short_name',
        sortDirection: 'asc',
      },
      {
        text: 'Bank Descending',
        icon: 'sort alphabet descending',
        sortColumn: 'banks.short_name',
        sortDirection: 'desc',
      },
      {
        text: 'Code Ascending',
        icon: 'sort alphabet ascending',
        sortColumn: 'bank_case.lead_id',
        sortDirection: 'asc',
      },
      {
        text: 'Code Descending',
        icon: 'sort alphabet descending',
        sortColumn: 'bank_case.lead_id',
        sortDirection: 'desc',
      },
    ];
    sortItems.push(...this.statusDateSortItems());
    const isMalaysia = this.props.auth.company && this.props.auth.company.countryCode === 'my';
    // CPI-1209: the plain Excel / CSV items. isCountryVietnam, not `!== 'my'`, which would add ID.
    const showPlainExports = isMalaysia ||
      isCountryVietnam(this.props.auth.company && this.props.auth.company.countryCode);
    const exportItems = currentTab === 'aging_by_lawyers' ? [
      {
        text: 'Excel',
        icon: 'download',
        onClick: async () => {
          const { store } = this.context;
          try {
            const response = await serverRequestGet(
              `/bookings/export/aging/lawyers/?${this.state.stringifyQuery}`,
              store,
            );
            if (response.error) {
              await store.dispatch(flashErrorMessage({ message: response.message }));
              return;
            }
            store.dispatch(flashSuccessMessage({
              header: t('Request Success', { ns: TRANSLATION_FILES.translation }),
              message: `${t('We are processing your report, will send via email once the report is ready', { ns: TRANSLATION_FILES.translation })}.`,
            }));
          } catch (err) {
            await store.dispatch(flashErrorMessage({ message: t('An error occurred, please refresh page', { ns: TRANSLATION_FILES.translation }) }));
          }
        },
      },
    ] : this.exportItemsManager();
    if (currentTab !== 'aging_by_lawyers' && showPlainExports) {
      exportItems.push(
        {
          text: 'Excel',
          icon: 'download',
          href: this.exportURL('excel'),
        },
        {
          text: 'CSV',
          icon: 'download',
          href: this.exportURL('csv'),
        },
        {
          isDivider: true,
        },
      );
    }
    if (currentTab !== 'aging_by_lawyers' && showsPaymentExcelExport(this.props.auth)) {
      exportItems.push({
        text: 'Payment\nExcel',
        icon: 'download',
        href: `${config.get('bookApiURL')}/bookings/export/payments/?`,
        dataTarget: 'paymentexcel',
      });
    }
    if (currentTab !== 'all' && currentTab !== 'aging_by_lawyers') {
      exportItems.push({
        text: 'Excel\n(detailed)',
        icon: 'download',
        href: this.exportURL('excel', false, true),
      });
    }
    return (
      <Grid verticalAlign="middle" padded="vertically">
        {
          isMobile ? (
            <Grid.Row>
              <Grid.Column width={16}>
                {this.renderAgingTabsMobile()}
              </Grid.Column>
            </Grid.Row>
          ) : (
            <Menu pointing secondary style={{ padding: '0.5em 0em 0em' }}>
              {
                tabss.map((tab, key) => (
                  <Menu.Item
                    className="uc-aging-tab"
                    style={{ backgroundColor: currentTab === tab.name ? '#E5FAF2' : 'transparent' }}
                    key={key}
                    name={tab.name}
                    onClick={this.handleChangeTab}
                    active={currentTab === tab.name}
                  >{titleCase(t(tab.text, { ns: namespaces[tab.name === 'all' ? 1 : 0] }))}</Menu.Item>
                ))
              }
            </Menu>
          )
        }
        <Grid.Row>
          <Grid.Column>
            {this.renderMenuTool()}
          </Grid.Column>
        </Grid.Row>

        {/* List Data */}
        <Grid.Row>
          <Grid.Column>
            <Dimmer
              inverted style={{ zIndex: 20 }}
              active={loading && data.length > 0}
            >
              <Loader inline="centered">{t('Loading', { ns: TRANSLATION_FILES.translation })}</Loader>
            </Dimmer>
            <Grid>
              <Grid.Row>
                <Grid.Column mobile={10} tablet={6} computer={6} verticalAlign="middle">
                  <Header as="h3">{this.getTabHeader()}</Header>
                </Grid.Column>
                <Grid.Column mobile={6} tablet={10} computer={10}>
                  <div style={{ display: 'flex', justifyContent: 'end', alignItems: 'center' }}>
                    {
                      exportItems.length > 0 && (
                        <Popup
                          size="tiny"
                          style={{ backgroundColor: '#596975' }}
                          basic
                          inverted
                          disabled={!isComputer}
                          content={t('Download', { ns: TRANSLATION_FILES.translation })}
                          position="top center"
                          trigger={
                            <div>
                              <SortButton
                                floated="right"
                                icon={
                                  <div
                                    style={{
                                      display: 'inline-flex',
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                      borderRadius: '50%',
                                      padding: '11px',
                                      transition: 'background-color 0.2s ease',
                                      cursor: 'pointer',
                                    }}
                                    onMouseEnter={e => e.currentTarget.style.backgroundColor = '#f4f5f7'}
                                    onMouseLeave={e => e.currentTarget.style.backgroundColor = 'transparent'}
                                  >
                                    <img src={DownloadSvg} width={20} alt="download" />
                                  </div>
                                }
                                loading={loading}
                                items={exportItems}
                              />
                            </div>
                          }
                        />
                      )
                    }
                    <Popup
                      size="tiny"
                      style={{ backgroundColor: '#596975' }}
                      basic
                      inverted
                      disabled={!isComputer}
                      content={t('Sort')}
                      position="top center"
                      trigger={
                        <div>
                          <SortButton
                            floated="right"
                            icon={
                              <div
                                style={{
                                  display: 'inline-flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  borderRadius: '50%',
                                  padding: '8px',
                                  transition: 'background-color 0.2s ease',
                                  cursor: 'pointer',
                                }}
                                onMouseEnter={e => e.currentTarget.style.backgroundColor = '#f4f5f7'}
                                onMouseLeave={e => e.currentTarget.style.backgroundColor = 'transparent'}
                              >
                                <img src={SortSvg} width={24} alt="sort" />
                              </div>
                            }
                            loading={loading}
                            items={sortItems}
                            onSort={this.handleSortData}
                          />
                        </div>
                      }
                    />
                  </div>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column width={16}>
                  <div style={{ overflowX: 'auto' }}>
                    <Table className="uc-table uc-booking-list-table" basic="very" sortable>
                      {this.renderTableHeaders(sortItems)}
                      <Table.Body>
                        {
                          data.length > 0 ?
                            data.map(this.renderTableRow) : (
                              <Table.Row>
                                <Table.Cell colSpan={10} textAlign="center">
                                  {
                                    loading ?
                                      <Loader active inline="centered">{t('Loading', { ns: TRANSLATION_FILES.translation })}</Loader>
                                    : <p>{t('No bookings found')}.</p>
                                  }
                                </Table.Cell>
                              </Table.Row>
                            )
                        }
                      </Table.Body>
                    </Table>
                  </div>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column textAlign="center">
            <PageNav
              upward
              currentPage={this.state.currentPage}
              count={this.state.count}
              limit={this.state.limit}
              offset={this.state.offset}
              dataSize={data.length}
              loading={loading}
              onChange={this.handleChangePage}
              noScrollTop={this.props.noScrollTop}
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
}

export default withTranslation(namespaces)(withRouter(connect(BookingsList.mapStateToProps)(BookingsList)));



// WEBPACK FOOTER //
// ./src/components/UpdatedComponents/UCBookingsList.jsx